/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"

// react
import { useContext, useEffect, useRef, useState } from "react"
import { Link, useHistory, useLocation, Prompt } from "react-router-dom"
import { Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../.."
// others
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import dayjs from "dayjs"
import util from "../../../ts/util"
// Kairos Components
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import {
  IsSearchingContext,
  GridInitializedContext,
  IsRestoreSearchingContext,
  IsPromptRefContext,
} from "../../../components/Context"
import { showInfoToast, showWarningToast } from "../../../components/CustomToast"
// Kairos Modal
import { ModalOuter } from "../../../components/Modal/ModalOuter"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import SyaryoSearchModal from "../../../components/SearchModal/SyaryoSearchModal"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import HinmeiSearchModal from "../../../components/SearchModal/HinmeiSearchModal"
import TumiOrosiSakiSearchModal from "../../../components/SearchModal/TumiOrosiSakiSearchModal"
import NinusiSeikyuSearchModal from "../../../components/SearchModal/NinusiSeikyuSearchModal"
// Kairos Others
import CONSTANT from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import { 区分分類コード } from "../../../constant/enum/codes"
import {
  e請求支払区分,
  受注配車区分,
  e請求支払確認区分,
  e課税区分,
  e配車状態区分,
} from "../../../constant/enum/zyutuHaisya"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import { clearAlert, setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import { RootState } from "../../../globalStore/rootreducer"
import { TApiResponse } from "../../../service/TApiResponse"
import { TZyutyuHaisyaListDeleteReq, TZyutyuHaisyaListGetRes } from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import zyutyuHaisyaService from "../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import { TZyutyuHaisyaPatternListGetRes } from "../../../service/order/zyutyuHaisyaPattern/TZyutyuHaisyaPattern"
import ZyutyuHaisyaPatternRegisterModal from "./ZyutyuHaisyaPatternRegisterModal"
import ZyutyuHaisyaPatternModal from "./ZyutyuHaisyaPatternModal/ZyutyuHaisyaPatternModal"
import {
  SearchConditionContext,
  SearchMethodContext,
  SearchResultContext,
  ZyutyubusyoContext,
} from "./ZyutyuHaisyaListContext"
import {
  パターンBindings,
  品名Bindings,
  支払Bindings,
  積地Bindings,
  卸地Bindings,
  積日Bindings,
  卸日Bindings,
  荷主Bindings,
  請求Bindings,
  車輌Bindings,
  乗務員売上Bindings,
  alignRightBindings,
  分割受注配車子入力不可Bindings,
  受領書Bindings,
} from "./ZyutyuHaisyaListConstant"

import { T車輌DataMap用Item, T支払先DataMap用Item, T傭車DataMap用Item } from "../../../type/gridDataMap"
import { T受注配車入力GridItem } from "./TZyutyuHaisyaList"
import { nameofT } from "../../../ts/util/typeUtil"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import ZyutyuHaisyaPatternService from "../../../service/order/zyutyuHaisyaPattern/zyutyuHaisyaPatternService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"

import _ from "lodash"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import RequiredHeader from "../../../components/FlexGridWrapper/RequiredHeader"
import Decimal from "decimal.js"
import SyaryoService from "../../../service/truck/syaryoService"
import commonUtil from "../../../ts/util/commonUtil"
import TumiorosisakiService from "../../../service/master/tumiorosisaki/tumiorosisakiService"
import { TTumiorosisakiListGetRes } from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import { e支払先区分, e計上基準日区分, e請求車輌区分 } from "../../../constant/enum/master"
import {
  get乗務員ItemsSourceByApi,
  itemsSourceFunctionSearchOuterDataMap,
  get車輌itemsSourceFunctionByDataMap,
  get積卸ItemsSourceByApi,
  get荷主ItemsSourceByApi,
  get品名ItemsSourceByApi,
  傭車DisplayNameFunc,
  build車輌DataMapList,
  get傭車itemsSourceFunctionByDataMap,
} from "../../../ts/util/autoCompleteUtil"
import { 全部所車番検索Enabled } from "../../../constant/featureFlags"
import HinmeiService from "../../../service/master/hinmei/hinmeiService"
import { T品名マスタ } from "../../../service/master/hinmei/THinmei"
import { TNinusiInfoGetRes } from "../../../service/master/ninusi/TNinusi"
import { TZyomuinListItem } from "../../../service/driver/TZyomuin"
import SiharaisakiSearchModal from "../../../components/SearchModal/SiharaisakiSearchModal"
import {
  castトレーラ車輌,
  cast乗務員,
  cast品名,
  cast積卸先,
  set配車状態区分By車輌ID,
  castヘッド車輌,
  setPattern as setPatternInner,
  T手入力チェック,
  set同乗者売上,
  同乗者売上計算,
  積載品入力時運送料自動計算,
  excelFormat,
  pdfFormat,
  is請求確認済,
  SYプロモーション特殊条件合致チェック,
  時間columns,
  castヘッド車輌By傭車,
  castトレーラ車輌By傭車,
  clear運行情報At傭車設定時,
  受領書DataMap,
} from "../../../ts/util/haisyaUtil"
import KosokuryoSearchModal from "../../../components/SearchModal/KosokuryoSearchModal"
import AGCKosokuryoSearchModal from "./AGCKosokuryoSearchModal/AGCKosokuryoSearchModal"
import constants from "../../../constant/constant"
import dateUtil from "../../../ts/util/dateUtil"
import { 支払先マスタ } from "../../../service/master/siharaisaki/TSiharaisaki"
import YosyaService from "../../../service/master/yosya/yosyaService"
import YosyaSearchModal from "../../../components/SearchModal/YosyaSearchModal"
import { T傭車マスタ } from "../../../service/master/yosya/TYosya"
import { useGridEventHandler } from "../../../ts/hooks/useGridEventHandler"
import ZyomuinService from "../../../service/driver/zyomuinService"
import stringUtil from "../../../ts/util/stringUtil"

/**
 * セルテンプレート内でのreadOnlyチェック用関数
 */
const cellReadOnlyFlag = (context: TWijmoCellTemplateContext<T受注配車入力GridItem>) =>
  !context.row.grid?.isReadOnly &&
  !context.row.isReadOnly &&
  !(context.item.分割情報 && context.item.分割情報.請求対象フラグ === 0)

/**
 * 受注配車入力grid部
 * @param props
 * @returns
 */
const ZyutyuHaisyaListGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
}> = (props) => {
  const history = useHistory()
  const location = useLocation()

  const { LoginUserInfo: userInfo } = useSelector((state: RootState) => state.user)

  const 休日List = useSelector((state: RootState) => state.date.休日List)

  const 受注配車入力PathList = util.getMenuPath(メニューコード.受注配車.受注配車入力)
  const 分割受注配車入力PathList = util.getMenuPath(メニューコード.受注配車.分割受注配車入力)

  //#region [context]
  const disPatch: AppDispatch = useDispatch()
  // ロード表示
  const { state: isSearching, setState: setIsSearching } = useContext(IsSearchingContext)
  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(GridInitializedContext)
  // gridレストア完了フラグ
  const { state: isRestoreSearching, setState: setIsRestoreSearching } = useContext(IsRestoreSearchingContext)

  // 検索結果
  const searchResult = useContext(SearchResultContext)
  const preSearchCondition = useContext(SearchConditionContext)
  const 受注部所コード = useContext(ZyutyubusyoContext)
  // 検索用メソッド
  const search = useContext(SearchMethodContext)

  // 画面遷移制御
  const isPrompt = useContext(IsPromptRefContext)
  const [forceUpdate, setForceUpdate] = useState(false)
  //#endregion

  //#region [state]
  //dataMap
  //表紙分割と請求内訳は動的生成
  const [表紙分割DataMap, set表紙分割DataMap] = useState<wjcGrid.DataMap<T表紙分割>>()
  const [表紙分割List, set表紙分割List] = useState<T表紙分割[]>([])
  const [請求内訳DataMap, set請求内訳DataMap] = useState<wjcGrid.DataMap<T請求内訳>>()
  const [請求内訳List, set請求内訳List] = useState<T請求内訳[]>([])

  const [運行部所DataMap, set運行部所DataMap] = useState<wjcGrid.DataMap<T部所マスタ>>()

  //区分系
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [単位区分DataMap, set単位区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [配車状態区分DataMap, set配車状態区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [車種区分DataMap, set車種区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [請求区分DataMap, set請求区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [課税区分DataMap, set課税区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [食事手当区分DataMap, set食事手当区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [計上基準日区分DataMap, set計上基準日区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [AGC高速料対象荷主コードList, setAGC高速料対象荷主コードList] = useState<string[]>([])
  const [乗務員List, set乗務員List] = useState<TZyomuinListItem[]>([])

  // dataMap
  const [車輌DataList, set車輌DataList] = useState<T車輌DataMap用Item[]>()
  const [車輌DataMap, set車輌DataMap] = useState<
    wjcGrid.DataMap<{
      name: string
      value: number
    }>
  >()

  const [傭車DataMap, set傭車DataMap] = useState<
    wjcGrid.DataMap<{
      name: string
      value: number
    }>
  >()

  const [支払先DataMap, set支払先DataMap] = useState<wjcGrid.DataMap<T支払先DataMap用Item>>()
  const [稼働手当車種掛率区分DataMap, set稼働手当車種掛率区分DataMap] = useState<wjcGrid.DataMap<T区分マスタ>>()
  const [selectedRows, setSelectedRows] = useState<wjcGrid.Row[]>([])

  // 編集用選択行確保state
  const [選択行, set選択行] = useState<wjcGrid.Row>()
  const [is複写Modal, setIs複写Modal] = useState(false)
  const [is受注配車パターン新規登録Modal, setIs受注配車パターン新規登録Modal] = useState(false)

  const [モーダル検索用荷主コード, setモーダル検索用荷主コード] = useState<string | undefined>()
  const [モーダル検索用荷主名, setモーダル検索用荷主名] = useState<string | undefined>()
  const [モーダル検索用車番, setモーダル検索用車番] = useState<string | undefined>()
  const [モーダル検索用乗務員名, setモーダル検索用乗務員名] = useState<string | undefined>()
  const [モーダル検索用積日, setモーダル検索用積日] = useState<string | undefined>()
  const [モーダル検索用卸日, setモーダル検索用卸日] = useState<string | undefined>()
  const [モーダル検索用積地, setモーダル検索用積地] = useState<string | undefined>()
  const [モーダル検索用卸地, setモーダル検索用卸地] = useState<string | undefined>()
  const [モーダル検索用受注配車ID, setモーダル検索用受注配車ID] = useState<number | undefined>()
  const [モーダル検索用高速料IDList, setモーダル検索用高速料IDList] = useState<number[] | undefined>()
  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  // 受注配車パターン検索
  const [is受注配車パターン検索Modal, setIs受注配車パターン検索Modal] = useState(false)
  const [部所List, set部所List] = useState<T部所マスタ[]>()

  const [select受注部所, setSelect受注部所] = useState<T部所マスタ>()

  // 積卸先検索
  const [is積卸先検索Modal, setIs積卸先検索Modal] = useState(false)
  const [積卸先検索対象, set積卸先検索対象] = useState<"積" | "卸">("積")

  // 品名検索
  const [is品名検索Modal, setIs品名検索Modal] = useState(false)

  // 車輌検索
  const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)
  const [車輌検索用部所コード, set車輌検索用部所コード] = useState<string | undefined>()
  const [車輌検索用原動機有無フラグ, set車輌検索用原動機有無フラグ] = useState<0 | 1 | undefined>()
  const [is傭車検索Modal, setIs傭車検索Modal] = useState(false)
  const [車輌検索用傭車会社コード, set車輌検索用傭車会社コード] = useState<string>()

  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)
  const [乗務員検索対象, set乗務員検索対象] = useState<"同乗者" | "乗務員">("乗務員")
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isDeleteConfirmModalShow, setIsDeleteConfirmModalShow] = useState(false)
  const [contextItem, setContextItem] = useState<T受注配車入力GridItem>()
  const [isDeleteRowConfirmModalShow, setIsDeleteRowConfirmModalShow] = useState(false)
  const [is荷主コード変更, setIs荷主コード変更] = useState(false)
  // 傭車先検索
  const [is傭車先検索Modal, setIs傭車先検索Modal] = useState(false)
  // 高速料検索
  const [is高速料検索Modal, setIs高速料検索Modal] = useState(false)
  // AGC高速料検索
  const [isAGC高速料検索Modal, setIsAGC高速料検索Modal] = useState(false)

  const [isGridRefresh, setIsGridRefresh] = useState(false)
  const [isListGot, setIsListGot] = useState(false)

  // filter用
  const editedRowData = useRef<T受注配車入力GridItem>()
  // Stateが作動しないとrefも動かないため一緒に設定
  // const [, setEditedRowData] = useState<T受注配車入力GridItem>()

  const [isDisabled登録ボタン, setIsDisabled登録ボタン] = useState(false)

  // エラーチェック用
  const 積日未存在List = useRef<Symbol[]>([])
  const 荷主コード未存在List = useRef<Symbol[]>([])
  const 表紙名未存在List = useRef<Symbol[]>([])
  const 請求内訳未存在List = useRef<Symbol[]>([])
  const 請求区分未存在List = useRef<Symbol[]>([])
  const 稼働手当未入力List = useRef<Symbol[]>([])

  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TZyutyuHaisyaListGetRes | T受注配車入力GridItem>, pageSize: number) => {
    // 支払先が取れてなかったのでつなげる
    const 支払先ItemsSource: 支払先マスタ[] = 支払先DataMap?.collectionView?.sourceCollection
    const newData: T受注配車入力GridItem[] = data.map((d) => {
      let is乗務員売上手編集 =
        (d.乗務員売上額 ?? 0) !== (d.請求運送料 ?? 0) ||
        (d.乗務員付帯料 ?? 0) !== (d.請求付帯料 ?? 0) ||
        (d.付帯高速料 ?? 0) !== (d.請求高速料 ?? 0)

      // 乗務員売上の手編集フラグは特殊条件に一致する場合、常にfalseにする
      if (SYプロモーション特殊条件合致チェック(d)) {
        is乗務員売上手編集 = false
      }
      const 同乗者場所区分 = 区分ItemSource?.find((e) => e.区分ID === d.同乗者場所区分ID)

      return {
        ...d,
        row_id: Symbol(),
        isSelected: false,
        支払先コード: 支払先ItemsSource?.find((s) => s?.支払先ID === d.支払先ID)?.支払先コード,
        傭車会社コード: 支払先ItemsSource?.find((s) => s?.支払先ID === d.支払先ID)?.支払先コード,
        品コード: d.品コード != null ? d.品コード : d.品名 != null ? CONSTANT.自由入力品コード : undefined,
        is乗務員売上手編集,
        bl受領書確認フラグ: d.受領書確認フラグ === 1,
        同乗者場所区分コード: 同乗者場所区分?.区分コード,
        同乗者場所区分ソート番号: 同乗者場所区分?.ソート番号,
        同乗者場所区分名称1: 同乗者場所区分?.名称1,
      }
    })

    return new wjCore.CollectionView<T受注配車入力GridItem>(newData, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        車輌最大積載量: (data: T受注配車入力GridItem) => data.トレーラ車種最大積載量 ?? data.最大積載量,
        受注No: (data: T受注配車入力GridItem) => {
          if (data.受注伝票番号 != null && data.受注伝票番号 !== "") {
            const text = `${data.受注伝票番号}${
              data.受注枝番 != null && data.受注枝番 > 0 ? `-${data.受注枝番}` : data.複写フラグ === 1 ? "-??" : ""
            }`
            return text
          } else {
            return ""
          }
        },
        padding車番: (data: T受注配車入力GridItem) => util.createPadding車番(data.車番),
        paddingトレーラ車番: (data: T受注配車入力GridItem) => util.createPadding車番(data.トレーラ車番),
        padding請求車番: (data: T受注配車入力GridItem) => util.createPadding車番(data.請求車番),
        支払合計: (data: T受注配車入力GridItem) => {
          const 支払運送料 = new Decimal(data.支払運送料 ?? 0)
          const 支払付帯料 = new Decimal(data.支払付帯料 ?? 0)
          const 支払高速料 = new Decimal(data.支払高速料 ?? 0)
          return 支払運送料.plus(支払付帯料).plus(支払高速料).toNumber()
        },
        請求合計: (data: T受注配車入力GridItem) => {
          const 請求運送料 = new Decimal(data.請求運送料 ?? 0)
          const 請求付帯料 = new Decimal(data.請求付帯料 ?? 0)
          const 請求高速料 = new Decimal(data.請求高速料 ?? 0)
          return 請求運送料.plus(請求付帯料).plus(請求高速料).toNumber()
        },
      },
    })
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    // handler付与
    grid.pastingCell.addHandler(pastingCell)

    // 休日リストがすでに入力されていた場合formatItemとbeginEditのイベントとも付与する
    if (休日List && 休日List.length > 0) {
      grid.formatItem.addHandler(formatItem)
      grid.beginningEdit.addHandler(beginningEdit)
    }
    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        const binding = c.binding as keyof T受注配車入力GridItem
        let setHeaderText = ""
        if (荷主Bindings.includes(binding)) {
          setHeaderText = "荷主"
        } else if (パターンBindings.includes(binding)) {
          setHeaderText = "パターンCD"
        } else if (積日Bindings.includes(binding)) {
          setHeaderText = "積日"
        } else if (卸日Bindings.includes(binding)) {
          setHeaderText = "卸日"
        } else if (積地Bindings.includes(binding)) {
          setHeaderText = "積地"
        } else if (卸地Bindings.includes(binding)) {
          setHeaderText = "卸地"
        } else if (品名Bindings.includes(binding)) {
          setHeaderText = "品名"
        } else if (車輌Bindings.includes(binding)) {
          setHeaderText = "車輌"
        } else if (請求Bindings.includes(binding)) {
          setHeaderText = "請求"
        } else if (支払Bindings.includes(binding)) {
          setHeaderText = "支払"
        } else if (乗務員売上Bindings.includes(binding)) {
          setHeaderText = "乗務員売上"
        } else if (受領書Bindings.includes(binding)) {
          setHeaderText = "受領書"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true

        // if (alignRightBindings.includes(binding)) {
        //   c.align = "right"
        // } else {
        //   c.align = "left"
        // }

        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
    columnHeaders.rows.forEach((row) => {
      row.height = 40
    })
    // ヘッダ以外のAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      let setTextAlign = ""
      if (panel.cellType !== wjcGrid.CellType.ColumnHeader) {
        if (alignRightBindings.includes(panel.columns[c].binding as keyof T受注配車入力GridItem)) {
          if (r !== 0) {
            setTextAlign = "right"
          }
        }
      } else {
        if (r === 0) {
          setTextAlign = "left"
        }
        cell.style.textAlign = setTextAlign
      }
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = async (s: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    let col = s.columns[e.col]

    if (e.cancel === true) {
      return
    }
    let newValue = s.getCellData(e.row, e.col, false)
    let dataItem: T受注配車入力GridItem = e.getRow().dataItem

    switch (col.binding as keyof TZyutyuHaisyaListGetRes) {
      case "積日":
        // 計上基準日区分を確認し、請求基準日を埋める
        if (dataItem.計上基準日区分コード === e計上基準日区分.積日) {
          dataItem.請求計上日 = newValue
        }
        break
      case "卸日":
        // 計上基準日区分を確認し、請求基準日を埋める
        if (dataItem.計上基準日区分コード === e計上基準日区分.卸日) {
          dataItem.請求計上日 = newValue
        }
        // 傭車会社が選択されていた場合、支払計上日を入力する
        if (dataItem.支払先ID) {
          dataItem.支払計上日 = newValue
        }
        break
      case "荷主コード":
        if (col.editor == null) return
        const 荷主Editor = col.editor as wjcInput.AutoComplete
        const 荷主selectedItem = 荷主Editor.selectedItem as TNinusiInfoGetRes
        if (荷主selectedItem == null) {
          dataItem.荷主コード = ""
          dataItem.荷主ID = undefined
          dataItem.荷主名 = undefined
        } else {
          dataItem.荷主コード = 荷主selectedItem.荷主コード
          dataItem.荷主ID = 荷主selectedItem.荷主ID
          dataItem.荷主名 = 荷主selectedItem.荷主略称1
          if (!dataItem.荷主依頼番号) {
            dataItem.荷主依頼番号 = 荷主selectedItem.荷主依頼番号接頭辞
          }
        }
        s.refresh()
        setIs荷主コード変更(true)
        break
      case nameofT<TZyutyuHaisyaListGetRes>("荷主請求ID"):
        if (newValue === e.data) return
        const 荷主請求: T表紙分割 = col.dataMap?.getDataItem(newValue)
        if (荷主請求) {
          dataItem.表紙分割コード = 荷主請求.表紙分割コード
        } else {
          dataItem.表紙分割コード = ""
        }
        // 変更時は荷主請求内訳を消去する
        dataItem.荷主請求内訳ID = undefined
        dataItem.計上基準日区分名称1 = undefined
        dataItem.計上基準日区分コード = undefined
        dataItem.請求車輌区分コード = undefined
        dataItem.請求車輌区分名称1 = undefined
        dataItem.請求車番 = undefined
        dataItem.請求計上日 = undefined
        dataItem.請求内訳コード = undefined
        // 税込高速料と品代端数計算区分を埋める
        if (newValue != null) {
          const 表紙分割 = 表紙分割List?.find((表紙分割) => 表紙分割.荷主請求ID === newValue)
          if (表紙分割) {
            dataItem.請求高速料税込区分コード = 表紙分割.高速料税込区分コード
            dataItem.請求高速料税込区分名称1 = 表紙分割.高速料税込区分名称1
            dataItem.支払高速料税込区分コード = 表紙分割.高速料税込区分コード
            dataItem.品代端数計算区分コード = 表紙分割.品代端数計算区分コード
            dataItem.品代端数計算区分ソート番号 = 表紙分割.品代端数計算区分ソート番号
            dataItem.品代端数計算区分名称1 = 表紙分割.品代端数計算区分名称1
          }
        }
        積載品入力時運送料自動計算(dataItem)
        s.refresh()
        break
      // case "荷主請求ID":
      //   dataItem.表紙名 = dataItem.荷主請求ID?.toString()
      //   break
      case "荷主請求内訳ID":
        if (newValue) {
          const 請求内訳 = 請求内訳List?.find(
            (i) => i.荷主請求内訳ID === newValue && i.荷主請求ID === dataItem.荷主請求ID
          )
          if (請求内訳) {
            // 計上基準日区分、請求車輌区分を自動で入れる
            dataItem.計上基準日区分名称1 = 請求内訳.計上基準日区分名称1
            dataItem.計上基準日区分コード = 請求内訳.計上基準日区分コード
            dataItem.請求内訳コード = 請求内訳.請求内訳コード
            switch (請求内訳.計上基準日区分コード) {
              case e計上基準日区分.積日:
                dataItem.請求計上日 = dataItem.積日
                break
              case e計上基準日区分.卸日:
                dataItem.請求計上日 = dataItem.卸日
                break

              default:
                break
            }

            dataItem.請求車輌区分コード = 請求内訳.請求車輌区分コード
            dataItem.請求車輌区分名称1 = 請求内訳.請求車輌区分名称1
            switch (請求内訳.請求車輌区分コード) {
              case e請求車輌区分.ヘッド:
                dataItem.請求車番 = dataItem.車番
                break
              case e請求車輌区分.トレーラー:
                dataItem.請求車番 = dataItem.トレーラ車番
                break

              default:
                break
            }
          } else {
            dataItem.計上基準日区分名称1 = undefined
            dataItem.計上基準日区分コード = undefined
            dataItem.請求車輌区分コード = undefined
            dataItem.請求車輌区分名称1 = undefined
            dataItem.請求車番 = undefined
            dataItem.請求計上日 = undefined
            dataItem.請求内訳コード = undefined
          }
        } else {
          dataItem.計上基準日区分名称1 = undefined
          dataItem.計上基準日区分コード = undefined
          dataItem.請求車輌区分コード = undefined
          dataItem.請求車輌区分名称1 = undefined
          dataItem.請求車番 = undefined
          dataItem.請求計上日 = undefined
          dataItem.請求内訳コード = undefined
        }
        積載品入力時運送料自動計算(dataItem)
        s.refresh()
        break
      case "受注配車パターンコード":
        // 空文字やnull undefinedのときはスルー
        // autoCOmpleteのバグ？なのかselectedValueではなく、displayMemberPathの値が入ってきてしまうため、
        // 現在のeditorを直接参照し、値を詰め込むようにする。
        if (col.editor == null) return
        const cellEditor = col.editor as wjcInput.AutoComplete

        if (cellEditor.selectedItem != null) {
          setPattern(cellEditor.selectedItem, dataItem)
          setIsListGot(true)
          setIs荷主コード変更(true)
          setIsGridRefresh(true)
        } else {
          // 文字列と完全一致するものがあったら登録
          if (cellEditor.text != null && cellEditor.text !== "") {
            const autoCompleteItems = cellEditor.collectionView.sourceCollection as TZyutyuHaisyaPatternListGetRes[]
            const targetPattern = autoCompleteItems.find(
              (i) => i.受注配車パターンコード === cellEditor.text && i.受注部所コード === 受注部所コード
            )
            if (targetPattern) {
              setPattern(targetPattern, dataItem)
              setIsGridRefresh(true)
            } else {
              // なかった場合、積卸と品名情報の複数登録は不可となるため、積地数・卸地数・品数を1に戻す
              dataItem.積地数 = 1
              dataItem.卸地数 = 1
              dataItem.品数 = 1
            }
          } else {
            // なかった場合、積卸と品名情報の複数登録は不可となるため、積地数・卸地数・品数を1に戻す
            dataItem.積地数 = 1
            dataItem.卸地数 = 1
            dataItem.品数 = 1
          }
        }

        s.refresh()
        break
      case "支払先コード":
        if (col.editor == null) return
        const 傭車会社Editor = col.editor as wjcInput.AutoComplete
        const 傭車会社selectedItem = 傭車会社Editor.selectedItem as T支払先DataMap用Item
        if (傭車会社selectedItem != null) {
          dataItem.支払先名 = 傭車会社selectedItem.支払先略称
          dataItem.支払先ID = 傭車会社selectedItem.支払先ID
          dataItem.傭車会社名 = 傭車会社selectedItem.支払先略称
          dataItem.傭車会社コード = 傭車会社selectedItem.支払先コード
          dataItem.支払先コード = 傭車会社selectedItem.支払先コード
          // 卸日より支払計上日を入力する
          if (dataItem.卸日) {
            dataItem.支払計上日 = dataItem.卸日
          }
          // 一致しなくなる運行情報系を削除する
          clear運行情報At傭車設定時(dataItem)
        } else {
          dataItem.傭車会社名 = ""
          dataItem.支払先名 = ""
          dataItem.支払先ID = undefined
          dataItem.傭車会社コード = ""
          dataItem.支払先コード = ""
        }
        s.refresh()
        break
      case "車番":
        // 空白のときは関連しているデータも消去する

        if (col.editor == null) return
        const 車輌cellEditor = col.editor as wjcInput.AutoComplete

        if (車輌cellEditor.selectedItem == null) {
          dataItem.車輌ID = undefined
          dataItem.車番 = undefined
          dataItem.車種区分コード = undefined
          dataItem.車種区分名称1 = undefined
          dataItem.最大積載量 = undefined
        } else {
          // 傭車の場合処理を変更する
          if (dataItem.支払先ID != null) {
            const 傭車 = 車輌cellEditor.selectedItem as T傭車DataMap用Item
            castヘッド車輌By傭車(dataItem, 傭車)
          } else {
            const 車輌 = 車輌cellEditor.selectedItem as T車輌DataMap用Item
            castヘッド車輌(dataItem, 車輌)
          }
        }
        // 請求車番を入力
        if (dataItem.請求車輌区分コード === e請求車輌区分.ヘッド) {
          dataItem.請求車番 = dataItem.車番
        }
        if (dataItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
          dataItem.請求車番 = dataItem.トレーラ車番
        }
        s.refresh()
        break
      case "トレーラ車番":
        if (col.editor == null) return
        const トレーラ車輌cellEditor = col.editor as wjcInput.AutoComplete

        if (トレーラ車輌cellEditor.selectedItem == null) {
          dataItem.トレーラ車輌ID = undefined
          dataItem.トレーラ車番 = undefined
          dataItem.トレーラ車種区分コード = undefined
          dataItem.トレーラ車種区分名称1 = undefined
          dataItem.トレーラ車種最大積載量 = undefined
        } else {
          // 傭車の場合処理を変更する
          if (dataItem.支払先ID != null) {
            const 傭車 = トレーラ車輌cellEditor.selectedItem as T傭車DataMap用Item
            castトレーラ車輌By傭車(dataItem, 傭車)
          } else {
            const 車輌 = トレーラ車輌cellEditor.selectedItem as T車輌DataMap用Item
            castトレーラ車輌(dataItem, 車輌)
          }
        }
        if (dataItem.請求車輌区分コード === e請求車輌区分.ヘッド) {
          dataItem.請求車番 = dataItem.車番
        }
        if (dataItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
          dataItem.請求車番 = dataItem.トレーラ車番
        }
        s.refresh()
        break
      case "積地積卸先コード":
        if (col.editor == null) return
        const 積地積卸先Editor = col.editor as wjcInput.AutoComplete
        cast積卸先(dataItem, 積地積卸先Editor.selectedItem as TTumiorosisakiListGetRes, "積")
        s.refresh()
        break
      case "積地社名":
      case "積地都道府県":
      case "積地市区町村":
        // 積地積卸先IDが存在する場合に検索を実行し、一致していない情報があった場合に手編集判定
        if (dataItem.積地積卸先ID != null) {
          const 積地Res = await new TumiorosisakiService().get(dataItem.積地積卸先ID)
          if (!積地Res) {
            dataItem.is積地手編集 = true
          } else {
            dataItem.is積地手編集 =
              dataItem.積地社名 !== 積地Res.data.積卸先略称 ||
              dataItem.積地都道府県 !== 積地Res.data.住所１ ||
              dataItem.積地市区町村 !== 積地Res.data.住所２
          }
        } else {
          dataItem.is積地手編集 = false
        }
        break
      case "卸地積卸先コード":
        const 卸地積卸先Editor = col.editor as wjcInput.AutoComplete
        cast積卸先(dataItem, 卸地積卸先Editor.selectedItem as TTumiorosisakiListGetRes, "卸")
        s.refresh()
        break
      case "卸地社名":
      case "卸地都道府県":
      case "卸地市区町村":
        // 卸地積卸先IDが存在する場合に検索を実行し、一致していない情報があった場合に手編集判定
        if (dataItem.卸地積卸先ID != null) {
          const 卸地Res = await new TumiorosisakiService().get(dataItem.卸地積卸先ID)
          if (!卸地Res) {
            dataItem.is卸地手編集 = true
          } else {
            dataItem.is卸地手編集 =
              dataItem.卸地社名 !== 卸地Res.data.積卸先略称 ||
              dataItem.卸地都道府県 !== 卸地Res.data.住所１ ||
              dataItem.卸地市区町村 !== 卸地Res.data.住所２
          }
        } else {
          dataItem.is卸地手編集 = false
        }
        break
      case "乗務員名":
      case "同乗者名":
        // 支払先ID(傭車会社)が入っているときは特に処理しない
        if (dataItem.支払先ID != null || col.editor == null) return
        const 乗務員Editor = col.editor as wjcInput.AutoComplete
        const 乗務員selectedItem = 乗務員Editor.selectedItem as TZyomuinListItem
        if (乗務員selectedItem != null) {
          if (col.binding === "乗務員名") {
            cast乗務員(dataItem, 乗務員selectedItem, "乗務員")
          } else {
            cast乗務員(dataItem, 乗務員selectedItem, "同乗者")
          }
        } else {
          //一件のときはそのデータを入れる
          let 乗務員selectedItem: TZyomuinListItem | null
          if (乗務員Editor.collectionView.sourceCollection.length === 1) {
            乗務員selectedItem = 乗務員Editor.collectionView.sourceCollection[0] as TZyomuinListItem
          } else {
            乗務員selectedItem = null
          }
          if (col.binding === "乗務員名") {
            cast乗務員(dataItem, 乗務員selectedItem, "乗務員")
          } else {
            cast乗務員(dataItem, 乗務員selectedItem, "同乗者")
          }
        }
        // 同乗者の場合、同乗者売り上げも操作する
        if (col.binding === "同乗者名") {
          if (dataItem.同乗者乗務員ID == null) {
            dataItem.同乗者売上額 = 0
          } else if (dataItem.同乗者売上額 === 0 || dataItem.同乗者売上額 == null) {
            dataItem.同乗者売上額 = set同乗者売上(dataItem)
          }
        }
        s.refresh()
        break
      case "品コード":
        const 品コードEditor = col.editor as wjcInput.AutoComplete
        cast品名(dataItem, 品コードEditor.selectedItem as T品名マスタ)
        積載品入力時運送料自動計算(dataItem)
        s.refresh()
        break
      case "品名":
      case "単位区分コード":
        if (newValue === e.data) return
        dataItem.is品名手編集 = true
        break
      case "積載品数量":
      case "単価":
        積載品入力時運送料自動計算(dataItem)
        s.refresh()
        break
      case "請求車番":
        // 手入力を行った時点でIDを消す
        // MEMO: ほかで使っていない項目なので特に気にせず消す
        dataItem.請求車輌ID = undefined
        s.refresh()
        break
      case "請求運送料":
        if (dataItem.is乗務員売上手編集) {
          break
        }

        dataItem.乗務員売上額 = dataItem.請求運送料
        dataItem.同乗者売上額 = set同乗者売上(dataItem)
        s.refresh()
        break
      case "請求付帯料":
        if (dataItem.is乗務員売上手編集) {
          break
        }
        dataItem.乗務員付帯料 = dataItem.請求付帯料
        s.refresh()
        break
      case "請求高速料":
        if (dataItem.is乗務員売上手編集) {
          break
        }
        dataItem.付帯高速料 = dataItem.請求高速料
        s.refresh()
        break
      default:
        break
    }

    // SYプロモーション特殊条件用
    if (SYプロモーション特殊条件合致チェック(dataItem)) {
      if (dataItem.請求付帯料 == null || dataItem.請求付帯料 === 0) {
        dataItem.請求付帯料 = constants.SYプロモーション特殊条件.付帯料
        dataItem.乗務員付帯料 = 0
        dataItem.請求備考 = constants.SYプロモーション特殊条件.請求備考
        s.refresh()
      }
    }
    editedRowData.current = undefined
  }

  const pastedCell = async (s: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    let col = s.columns[e.col]

    if (e.cancel === true) {
      return
    }
    let dataItem: T受注配車入力GridItem = e.getRow().dataItem
    const colBindingName = col.binding as keyof T受注配車入力GridItem
    switch (colBindingName) {
      case "乗務員名":
      case "同乗者名":
        // 傭車の場合は処理しない
        if (!wjCore.isNullOrWhiteSpace(dataItem.傭車会社コード ?? "")) break
        const 対象乗務員List = 乗務員List.filter((z) =>
          stringUtil.compareWithoutWhiteSpace(z.社員氏名, dataItem[colBindingName])
        )

        if (対象乗務員List.length === 1) {
          if (colBindingName.includes("乗務員名")) {
            cast乗務員(dataItem, 対象乗務員List[0], "乗務員")
          } else {
            cast乗務員(dataItem, 対象乗務員List[0], "同乗者")
          }
          s.refresh()
        } else if (!wjCore.isNullOrWhiteSpace(dataItem[colBindingName] ?? "")) {
          if (colBindingName.includes("乗務員名")) {
            cast乗務員(dataItem, null, "乗務員")
          } else {
            cast乗務員(dataItem, null, "同乗者")
          }
          s.refresh()
          showWarningToast("正確な乗務員を取得できないため、入力できませんでした。")
        }
        break
      case "積日":
        // 計上基準日区分を確認し、請求基準日を埋める
        if (dataItem.計上基準日区分コード === e計上基準日区分.積日) {
          dataItem.請求計上日 = dataItem.積日
        }
        break
      case "卸日":
        // 計上基準日区分を確認し、請求基準日を埋める
        if (dataItem.計上基準日区分コード === e計上基準日区分.卸日) {
          dataItem.請求計上日 = dataItem.卸日
        }
        // 傭車会社が選択されていた場合、支払計上日を入力する
        if (dataItem.支払先ID) {
          dataItem.支払計上日 = dataItem.卸日
        }
        break
      case "積載品数量":
      case "単価":
        積載品入力時運送料自動計算(dataItem)
        s.refresh()
        break
      case "請求運送料":
        if (dataItem.is乗務員売上手編集) {
          break
        }

        dataItem.乗務員売上額 = dataItem.請求運送料
        dataItem.同乗者売上額 = set同乗者売上(dataItem)
        s.refresh()
        break
      case "請求付帯料":
        if (dataItem.is乗務員売上手編集) {
          break
        }
        dataItem.乗務員付帯料 = dataItem.請求付帯料
        s.refresh()
        break
      case "請求高速料":
        if (dataItem.is乗務員売上手編集) {
          break
        }
        dataItem.付帯高速料 = dataItem.請求高速料
        s.refresh()
        break
      default:
        break
    }

    // SYプロモーション特殊条件用
    if (SYプロモーション特殊条件合致チェック(dataItem)) {
      if (dataItem.請求付帯料 == null || dataItem.請求付帯料 === 0) {
        dataItem.請求付帯料 = constants.SYプロモーション特殊条件.付帯料
        dataItem.乗務員付帯料 = 0
        dataItem.請求備考 = constants.SYプロモーション特殊条件.請求備考
        s.refresh()
      }
    }
    editedRowData.current = undefined
  }

  const beginningEditOrPastingCellInner = (s: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    let col = s.columns[e.col]
    const binding = col.binding as keyof T受注配車入力GridItem
    let dataItem: T受注配車入力GridItem = e.getRow().dataItem
    editedRowData.current = dataItem
    // 請求額確認済みの場合は編集不可
    if (is請求確認済(dataItem)) {
      e.cancel = true
      return
    }

    // 分割受注配車の子レコードは一部修正不可
    // 親レコード更新時に同時に更新を行う
    if (dataItem.分割情報 && dataItem.分割情報.請求対象フラグ === 0) {
      if (分割受注配車子入力不可Bindings.includes(binding)) {
        e.cancel = true
        return
      }
    }

    switch (binding) {
      case "受注配車パターンコード":
        if (dataItem.受注配車ID != null && dataItem.受注配車ID !== 0) {
          e.cancel = true
          return
        }
        break
      case "積日":
      case "積時間":
      case "積地積卸先コード":
      case "積地社名":
      case "積地都道府県":
      case "積地市区町村":
        if (dataItem.積地数 != null && dataItem.積地数 > 1) {
          e.cancel = true
          return
        }
        break
      case "卸日":
      case "卸時間":
      case "卸地積卸先コード":
      case "卸地社名":
      case "卸地都道府県":
      case "卸地市区町村":
        // 卸地情報が複数の場合readOnlyに設定
        if (dataItem.卸地数 != null && dataItem.卸地数 > 1) {
          e.cancel = true
          return
        }
        break
      case "品名":
        // 卸地情報が複数の場合readOnlyに設定
        if (dataItem.品数 != null && dataItem.品数 > 1) {
          e.cancel = true
          return
        }
        // 品名が99999でない場合はreadOnlyに設定
        if (dataItem.品コード !== CONSTANT.自由入力品コード) {
          e.cancel = true
          return
        }
        break
      case "品コード":
      case "単位区分コード":
      case "積載品数量":
        // 卸地情報が複数の場合readOnlyに設定
        if (dataItem.品数 != null && dataItem.品数 > 1) {
          e.cancel = true
          return
        }
        break
      //請求区分が「品数毎」ではない場合、単価は登録されないため入力不可とする。
      // また、複数の場合も入力不可
      case "単価":
        if (dataItem.請求区分コード == null || dataItem.請求区分コード !== e請求支払区分.品数毎) {
          e.cancel = true
          return
        }
        if (dataItem.品数 != null && dataItem.品数 > 1) {
          e.cancel = true
          return
        }
        break
      case "食事手当":
      case "稼働手当車種掛率区分コード":
        if (dataItem.支払先ID != null) {
          e.cancel = true
          return
        }
        break
      case "乗務員売上額":
      case "乗務員付帯料":
      case "付帯高速料":
        if (!dataItem.is乗務員売上手編集) {
          e.cancel = true
          return
        }
        break
      default:
        break
    }
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (s: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    let col = s.columns[e.col]
    let dataItem: T受注配車入力GridItem = e.getRow().dataItem
    editedRowData.current = dataItem

    beginningEditOrPastingCellInner(s, e)

    // 時間対象のカラムのとき、日曜と休日に色付け
    時間columns.forEach((binding) => {
      if (col.binding === binding && col.editor) {
        const editor = col.editor as wjcInput.InputDate
        editor.calendar.formatItem.removeAllHandlers()
        // 積日と卸日のときはさらに休日も色付け
        editor.calendar.formatItem.addHandler(
          dateUtil.inputDateOffDayFormatHandler(["積日", "卸日"].includes(binding) ? 休日List : [])
        )
      }
    })
  }

  const pastingCell = beginningEditOrPastingCellInner

  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding as keyof T受注配車入力GridItem
      const targetRow = e.getRow()
      const dataItem: T受注配車入力GridItem = targetRow.dataItem

      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
        //請求額確認済みの行はreadonly
        if (is請求確認済(dataItem)) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
        targetRow.cssClass = dataItem.isSelected ? "edit-row" : ""
        targetRow.isReadOnly = !dataItem.isSelected

        switch (cellBinding) {
          case "受注配車パターンコード":
            wjCore.toggleClass(e.cell, "read-only-cell", dataItem.受注配車ID != null && dataItem.受注配車ID !== 0)
            break
          case "荷主コード":
            if (荷主コード未存在List.current != null && 荷主コード未存在List.current.length > 0) {
              const is未存在 = 荷主コード未存在List.current.find((d) => d === dataItem.row_id) ? true : false
              wjCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          case "荷主請求ID":
            if (表紙名未存在List.current != null && 表紙名未存在List.current.length > 0) {
              const is未存在 = 表紙名未存在List.current.find((d) => d === dataItem.row_id) ? true : false
              wjCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          case "荷主請求内訳ID":
            if (請求内訳未存在List.current != null && 請求内訳未存在List.current.length > 0) {
              const is未存在 = 請求内訳未存在List.current.find((d) => d === dataItem.row_id) ? true : false
              wjCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          case "請求区分コード":
            if (請求区分未存在List.current != null && 請求区分未存在List.current.length > 0) {
              const is未存在 = 請求区分未存在List.current.find((d) => d === dataItem.row_id) ? true : false
              wjCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          case "積日":
            if (積日未存在List.current != null && 積日未存在List.current.length > 0) {
              const is未存在 = 積日未存在List.current.find((d) => d === dataItem.row_id) ? true : false
              wjCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            // 積地情報が複数の場合readOnlyに設定
            wjCore.toggleClass(e.cell, "read-only-cell", dataItem.積地数 != null && dataItem.積地数 > 1)

            // 休日の場合は色を変更
            wjCore.toggleClass(e.cell, "date-sunday", dateUtil.HolidayCheck(dataItem.積日, 休日List) === 1)
            wjCore.toggleClass(e.cell, "date-holiday", dateUtil.HolidayCheck(dataItem.積日, 休日List) === 2)

            break
          case "積時間":
          case "積地積卸先コード":
          case "積地社名":
          case "積地都道府県":
          case "積地市区町村":
            // 積地情報が複数の場合readOnlyに設定
            wjCore.toggleClass(e.cell, "read-only-cell", dataItem.積地数 != null && dataItem.積地数 > 1)
            // 手入力での編集が行われていた場合青文字に設定
            wjCore.toggleClass(e.cell, "text-primary", dataItem.is積地手編集 != null ? dataItem.is積地手編集 : false)
            break
          case "卸日":
            // 休日の場合は色を変更
            wjCore.toggleClass(e.cell, "date-sunday", dateUtil.HolidayCheck(dataItem.卸日, 休日List) === 1)
            wjCore.toggleClass(e.cell, "date-holiday", dateUtil.HolidayCheck(dataItem.卸日, 休日List) === 2)

            break
          case "卸時間":
          case "卸地積卸先コード":
          case "卸地社名":
          case "卸地都道府県":
          case "卸地市区町村":
            // 卸地情報が複数の場合readOnlyに設定
            wjCore.toggleClass(e.cell, "read-only-cell", dataItem.卸地数 != null && dataItem.卸地数 > 1)
            // 手入力での編集が行われていた場合青文字に設定
            wjCore.toggleClass(e.cell, "text-primary", dataItem.is卸地手編集 != null ? dataItem.is卸地手編集 : false)
            break
          case "品名":
            // 品数が複数の場合readOnlyに設定
            // 品コードが99999でない場合はreadOnlyに設定
            wjCore.toggleClass(
              e.cell,
              "read-only-cell",
              (dataItem.品数 != null && dataItem.品数 > 1) || dataItem.品コード !== CONSTANT.自由入力品コード
            )
            // 品コードが99999の場合青文字に設定
            wjCore.toggleClass(e.cell, "text-primary", dataItem.品コード === CONSTANT.自由入力品コード)
            break
          case "品コード":
          case "単位区分コード":
          case "積載品数量":
            // 品数が複数の場合readOnlyに設定
            wjCore.toggleClass(e.cell, "read-only-cell", dataItem.品数 != null && dataItem.品数 > 1)
            // 品コードが99999の場合青文字に設定
            wjCore.toggleClass(e.cell, "text-primary", dataItem.品コード === CONSTANT.自由入力品コード)
            break
          //請求区分が「品数毎」ではない場合、単価は登録されないため入力不可とする。
          //品数が複数の場合も同様
          case "単価":
            wjCore.toggleClass(
              e.cell,
              "read-only-cell",
              (dataItem.品数 != null && dataItem.品数 > 1) ||
                dataItem.請求区分コード == null ||
                dataItem.請求区分コード !== e請求支払区分.品数毎
            )
            break
          case "食事手当":
            wjCore.toggleClass(e.cell, "read-only-cell", dataItem.支払先ID != null)
            break
          case "乗務員売上額":
          case "乗務員付帯料":
          case "付帯高速料":
            wjCore.toggleClass(e.cell, "read-only-cell", !dataItem.is乗務員売上手編集)
            break
          case "稼働手当車種掛率区分コード":
            if (稼働手当未入力List.current != null && 稼働手当未入力List.current.length > 0) {
              const is未存在 = 稼働手当未入力List.current.find((d) => d === dataItem.row_id) ? true : false
              wjCore.toggleClass(e.cell, "data-warning", is未存在)
            }
            break
          default:
            break
        }

        // 既にreadOnlyになっていた場合処理しない
        if (!wjCore.hasClass(e.cell, "read-only-cell")) {
          // 分割された受注配車で、子側の受注配車に関しては一部編集不可とする
          wjCore.toggleClass(
            e.cell,
            "read-only-cell",
            分割受注配車子入力不可Bindings.includes(cellBinding) &&
              dataItem.分割情報 != null &&
              dataItem.分割情報.請求対象フラグ !== 1
          )
        }
      }
    }
  }

  const 車輛検索ButtonOnCLickHandler =
    (inner原動機有無フラグ: 0 | 1) =>
    (context: TWijmoCellTemplateContext<T受注配車入力GridItem>) =>
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault()
      set車輌検索用原動機有無フラグ(inner原動機有無フラグ)
      if (!全部所車番検索Enabled) set車輌検索用部所コード(context.item.運行部所コード)
      set選択行(context.row)
      if (context.item.支払先ID != null) {
        set車輌検索用傭車会社コード(context.item.傭車会社コード)
        setIs傭車検索Modal(true)
      } else {
        setIs車輌検索Modal(true)
      }
    }
  const ヘッド車輛検索ButtonOnCLickHandler = 車輛検索ButtonOnCLickHandler(1)
  const トレーラ車輛検索ButtonOnCLickHandler = 車輛検索ButtonOnCLickHandler(0)

  const 乗務員同乗者AutoCompleteProperties: (
    propertyName: "乗務員名" | "同乗者名"
  ) => React.ComponentProps<typeof wjrInput.AutoComplete> = (propertyName: "乗務員名" | "同乗者名") => ({
    minLength: 1,
    isEditable: false,
    delay: 10,
    gotFocus: (control: wjcInput.AutoComplete) => {
      // クリック時に前回の入力値が消えるのでtextの埋めなおし
      const rowData = editedRowData.current
      control.text = rowData ? rowData[propertyName] ?? "" : ""
      control.isEditable = rowData?.支払先ID != null
    },
    itemsSourceFunction: (query: string, max: number, callback: wjcInput.IGetItemsCallback) => {
      const 部所コード = editedRowData.current?.運行部所コード
      const 支払先ID = editedRowData.current?.支払先ID
      if (部所コード == null || 部所コード === "" || 支払先ID != null) {
        callback([])
        return
      }
      return get乗務員ItemsSourceByApi(query, max, callback, 部所コード)
    },
    displayMemberPath: "displayName",
    selectedValuePath: "社員氏名",
  })

  const 乗務員AutoCompleteProperties = 乗務員同乗者AutoCompleteProperties("乗務員名")
  const 同乗者AutoCompleteProperties = 乗務員同乗者AutoCompleteProperties("同乗者名")

  /**
   * 複写イベント
   * 選択行を別受注もしくは枝番追加で複写する
   * @param {*} e
   */
  const 複写 = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, 複製type: "枝番" | "別受注") => {
    if (flexGrid == null || selectedRows == null || selectedRows.length <= 0) return
    const addDataList: T受注配車入力GridItem[] = []

    const selectedRowIds = flexGrid?.rows
      .filter(
        (r) =>
          r != null &&
          r.dataItem != null &&
          r.dataItem.row_id != null &&
          selectedRows.find((row) => row.dataItem.row_id === r.dataItem.row_id)
      )
      .map((row) => row.dataItem.row_id)

    selectedRows.forEach((row) => {
      const item: TZyutyuHaisyaListGetRes = row.dataItem
      // 新規行の複写はしない
      if (item.複写フラグ === 1) return

      const newRowId = Symbol()

      const newData = copy(item, newRowId)
      if (複製type === "別受注") newData.受注伝票番号 = undefined
      if (select受注部所) {
        newData.受注部所コード = select受注部所.部所コード
        newData.受注部所名 = select受注部所.部所略称
      }
      newData.受注枝番 = 0
      addDataList.push(newData)
      selectedRowIds.push(newRowId)
    })

    gridData.data.beginUpdate()
    addDataList.forEach((newData) => {
      gridData.data.addNew(newData)
    })
    gridData.data.commitNew()
    gridData.data.endUpdate()

    // 新規行含めた選択行再登録
    const newSelectRows: wjcGrid.Row[] = []

    flexGrid?.refresh()
    flexGrid?.rows.forEach((row) => {
      if (row.dataItem.row_id == null) return
      if (selectedRowIds?.find((sr) => sr === row.dataItem.row_id)) {
        newSelectRows.push(row)
        row.dataItem.isSelected = true
      }
    })
    setSelectedRows([...newSelectRows])
    setIsDisabled登録ボタン(false)
  }

  const copy = (item: TZyutyuHaisyaListGetRes, newRowId: symbol): T受注配車入力GridItem => ({
    row_id: newRowId,
    複写フラグ: 1,
    受注配車ID: item.受注配車ID,
    // 完全新規の行の複写の場合のみパターンコードも一緒にコピーする
    受注配車パターンコード: item.受注配車ID ? undefined : item.受注配車パターンコード,
    受注伝票番号: item.受注伝票番号,
    // 複写のため枝番を増やす
    受注枝番: item.受注枝番,
    荷主ID: item.荷主ID,
    荷主コード: item.荷主コード,
    荷主名: item.荷主名,
    荷主請求ID: item.荷主請求ID,
    表紙名: item.表紙名,
    品代端数計算区分コード: item.品代端数計算区分コード,
    品代端数計算区分ソート番号: item.品代端数計算区分ソート番号,
    品代端数計算区分名称1: item.品代端数計算区分名称1,
    受注配車区分コード: item.受注配車区分コード,
    受注配車区分名称1: item.受注配車区分名称1,
    荷主依頼番号: item.荷主依頼番号,
    コンテナNO: item.コンテナNO,
    コンテナサイズ: item.コンテナサイズ,
    コンテナ軸: item.コンテナ軸,
    繰返運行数: item.繰返運行数,
    配送順: item.配送順,
    輸送備考: item.輸送備考,
    コース編集: item.コース編集,
    配車状態区分コード: item.配車状態区分コード,
    配車状態区分名称1: item.配車状態区分名称1,
    受注部所コード: item.受注部所コード,
    受注部所名: item.受注部所名,
    運行部所コード: item.運行部所コード,
    運行部所名: item.運行部所名,
    付替区分コード: item.付替区分コード,
    付替区分名称1: item.付替区分名称1,
    支払先コード: item.支払先コード,
    支払先名: item.支払先名,
    支払先ID: item.支払先ID,
    傭車会社コード: item.傭車会社コード,
    傭車会社名: item.傭車会社名,
    車輌ID: item.車輌ID,
    車種区分コード: item.車種区分コード,
    車種区分名称1: item.車種区分名称1,
    車番: item.車番,
    最大積載量: item.最大積載量,
    トレーラ車輌ID: item.トレーラ車輌ID,
    トレーラ車種区分コード: item.トレーラ車種区分コード,
    トレーラ車種区分名称1: item.トレーラ車種区分名称1,
    トレーラ車番: item.トレーラ車番,
    トレーラ車種最大積載量: item.トレーラ車種最大積載量,
    乗務員ID: item.乗務員ID,
    乗務員コード: item.乗務員コード,
    乗務員名: item.乗務員名,
    稼働手当車種掛率区分コード: item.稼働手当車種掛率区分コード,
    同乗者乗務員ID: item.同乗者乗務員ID,
    同乗者コード: item.同乗者コード,
    同乗者名: item.同乗者名,
    同乗者場所区分ID: item.同乗者場所区分ID,
    同乗者場所区分コード: item.同乗者場所区分コード,
    同乗者場所区分名称1: item.同乗者場所区分名称1,
    食事手当: item.食事手当,
    稼働手当: item.稼働手当,
    特別手当: item.特別手当,
    その他手当: item.その他手当,
    請求内訳コード: item.請求内訳コード,
    請求内訳名: item.請求内訳名,
    請求区分コード: item.請求区分コード,
    請求区分名称1: item.請求区分名称1,
    請求車輌区分名称1: item.請求車輌区分名称1,
    請求車輌区分ソート番号: item.請求車輌区分ソート番号,
    請求車輌区分コード: item.請求車輌区分コード,
    請求運送料課税区分コード: item.請求運送料課税区分コード,
    請求運送料課税区分名称1: item.請求運送料課税区分名称1,
    請求運送料: item.請求運送料,
    請求付帯料課税区分コード: item.請求付帯料課税区分コード,
    請求付帯料課税区分名称1: item.請求付帯料課税区分名称1,
    請求付帯料: item.請求付帯料,
    請求高速料税込区分コード: item.請求高速料税込区分コード,
    請求高速料税込区分名称1: item.請求高速料税込区分名称1,
    請求高速料: item.請求高速料,
    高速料記号: item.高速料記号,
    計上基準日区分コード: item.計上基準日区分コード,
    計上基準日区分名称1: item.計上基準日区分名称1,
    請求計上日: item.請求計上日,
    請求備考: item.請求備考,
    請求額確認区分コード: item.請求額確認区分コード,
    請求額確認区分名称1: item.請求額確認区分名称1,
    請求車輌ID: item.請求車輌ID,
    請求車番: item.請求車番,
    支払運送料: item.支払運送料,
    支払付帯料: item.支払付帯料,
    支払高速料: item.支払高速料,
    支払計上日: item.支払計上日,
    支払備考: item.支払備考,
    支払額確認区分コード: item.支払額確認区分コード,
    支払額確認区分名称1: item.支払額確認区分名称1,
    乗務員売上額: item.乗務員売上額,
    乗務員付帯料: item.乗務員付帯料,
    付帯高速料: item.付帯高速料,
    同乗者売上額: item.同乗者売上額,
    荷主請求内訳ID: item.荷主請求内訳ID,
    削除フラグ: item.削除フラグ,
    作成日時: item.作成日時,
    更新日時: item.更新日時,
    // 先頭の積卸データ
    積日: item.積日,
    積時間: item.積時間,
    積地ID: item.積地ID,
    積地積卸先ID: item.積地積卸先ID,
    積地積卸先コード: item.積地積卸先コード,
    積地社名: item.積地社名,
    積地都道府県: item.積地都道府県,
    積地市区町村: item.積地市区町村,
    卸日: item.卸日,
    卸時間: item.卸時間,
    卸地ID: item.卸地ID,
    卸地積卸先ID: item.卸地積卸先ID,
    卸地積卸先コード: item.卸地積卸先コード,
    卸地社名: item.卸地社名,
    卸地都道府県: item.卸地都道府県,
    卸地市区町村: item.卸地市区町村,
    荷主品名ID: item.荷主品名ID,
    品コード: item.品コード,
    品名: item.品名,
    積地数: item.積地数,
    卸地数: item.卸地数,
    品数: item.品数,
    単価: item.単価,
    積載品数量: item.積載品数量,
    単位区分コード: item.単位区分コード,
    AGC高速料マスタID: item.AGC高速料マスタID,
    isSelected: true,
  })

  /**
   * 新規行追加
   */
  const addRow = () => {
    const newSelectRows: wjcGrid.Row[] = []
    // 選択状態の保持
    const selectedRowIds = flexGrid?.rows
      .filter(
        (r) =>
          r != null &&
          r.dataItem != null &&
          r.dataItem.row_id != null &&
          selectedRows.find((row) => row.dataItem.row_id === r.dataItem.row_id)
      )
      .map((row) => row.dataItem.row_id)
    const newRowId = Symbol()
    const newItem: Partial<T受注配車入力GridItem> = {
      row_id: newRowId,
      isSelected: true,
      受注配車ID: undefined,
      荷主コード: "",
      受注部所コード: 受注部所コード,
      複写フラグ: 1,
      積地数: 1,
      卸地数: 1,
      繰返運行数: 1,
      積日: preSearchCondition?.検索日From,
      卸日: preSearchCondition?.検索日From,
      運行部所ID: userInfo.運行部所フラグ === 1 ? userInfo.部所ID ?? undefined : undefined,
      運行部所コード: userInfo.運行部所フラグ === 1 ? userInfo.部所コード ?? undefined : undefined,
      運行部所名: userInfo.運行部所フラグ === 1 ? userInfo.部所略称 ?? undefined : undefined,
      請求付帯料課税区分コード: e課税区分.課税,
      請求運送料課税区分コード: e課税区分.課税,
    }
    gridData.data.beginUpdate()
    gridData.data.addNew(newItem)
    gridData.data.commitNew()
    gridData.data.endUpdate()
    const newRow = flexGrid?.rows.find((r) => r.dataItem.row_id && r.dataItem.row_id === newRowId)
    if (newRow) {
      newSelectRows.push(newRow)
    }
    flexGrid?.rows.forEach((row) => {
      if (row.dataItem.row_id == null) return
      if (selectedRowIds?.find((sr) => sr === row.dataItem.row_id)) {
        newSelectRows.push(row)

        row.dataItem.isSelected = true
      }
    })
    flexGrid?.refresh()
    isPrompt.current = true
    setSelectedRows([...newSelectRows])
    setIsDisabled登録ボタン(false)
  }

  const createコース編集 = (dataItem: TZyutyuHaisyaListGetRes) => {
    let コース編集Text = ` ${dataItem.積地社名 ?? ""}${dataItem.積地社名 ? " " : ""}${dataItem.積地市区町村 ?? ""}${
      dataItem.積地社名 ? "～" : ""
    }${dataItem.卸地社名 ?? ""}${dataItem.卸地社名 ? " " : ""}${dataItem.卸地市区町村 ?? ""}`
    return コース編集Text
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    let messages: string[] = []
    let isError = false
    const gridItems: T受注配車入力GridItem[] = gridData.data.items
    const putData: T受注配車入力GridItem[] = []
    gridItems.forEach((d) => {
      // 品数がnullの場合は1を入れる
      if (!d.品数) {
        d.品数 = 1
      }
      // 複写フラグがある行は選択していなくても登録する
      if (d.複写フラグ) {
        d.受注配車区分コード = 受注配車区分.通常貨物

        putData.push(d)
      }
    })
    if (selectedRows) {
      selectedRows.forEach((row) => {
        if (!row.dataItem.複写フラグ) {
          const item: T受注配車入力GridItem = row.dataItem
          putData.push(item)
        }
      })
    }

    // 必須チェック
    const 必須Valid = 必須validate(putData)
    isError = 必須Valid.hasError === true ? true : isError
    messages.push(...必須Valid.messages)

    if (isError) {
      disPatch(setWarningAlerts(messages))
      flexGrid?.refresh()
      return
    }
    setIsConfirmModalShow(true)
  }

  /**
   * エラークリア
   */
  const clearError = () => {
    disPatch(clearAlert())
  }

  /**
   * 必須チェック
   * @param putData: T受注配車入力GridItem[]
   */
  const 必須validate = (putData: T受注配車入力GridItem[]) => {
    let 必須エラー = false
    let 表紙名エラー = false
    let 積卸情報エラー = false
    let 荷主コードエラー = false
    let 請求内訳エラー = false
    let 請求区分エラー = false
    let 稼働手当エラー = false
    const エラーメッセージList: string[] = []

    if (受注部所コード == null || 受注部所コード === "") {
      必須エラー = true
      エラーメッセージList.push("受注部所は必須入力です")
    }

    // グリッド内の必須確認
    // TODO: schemaを使ったチェックに変更予定
    putData.forEach((d) => {
      if (d.積日 == null || d.積日 === "") {
        if (!積卸情報エラー) {
          積卸情報エラー = true
          エラーメッセージList.push("積日は必須入力です")
        }
        積日未存在List.current.push(d.row_id)
      }
      if (d.荷主コード == null || d.荷主コード === "") {
        if (!荷主コードエラー) {
          荷主コードエラー = true
          エラーメッセージList.push("荷主コードは必須入力です")
        }
        荷主コード未存在List.current.push(d.row_id)
      }
      if (d.荷主請求ID == null) {
        if (!表紙名エラー) {
          表紙名エラー = true
          エラーメッセージList.push("表紙名は必須入力です")
        }
        表紙名未存在List.current.push(d.row_id)
      }
      if (d.荷主請求内訳ID == null) {
        if (!請求内訳エラー) {
          請求内訳エラー = true
          エラーメッセージList.push("請求内訳は必須入力です")
        }
        請求内訳未存在List.current.push(d.row_id)
      }
      if (d.請求区分コード == null || d.請求区分コード === "") {
        if (!請求区分エラー) {
          請求区分エラー = true
          エラーメッセージList.push("請求区分は必須入力です")
        }
        請求区分未存在List.current.push(d.row_id)
      }
      // 傭車以外で車輌が存在するときに、稼働掛率の入っていない車輌が存在していた場合エラーとする
      if (d.車輌ID != null && wjCore.isNullOrWhiteSpace(d.稼働手当車種掛率区分コード ?? "")) {
        if (!稼働手当エラー) {
          稼働手当エラー = true
          エラーメッセージList.push(
            "稼働掛率が設定されていない車輌です。稼働掛率の設定を依頼して下さい",
            "車番手入力後、キーボードの↓を押して、TABキーを2回押すと、稼働掛率が反映されます。"
          )
        }
        稼働手当未入力List.current.push(d.row_id)
      }
    })

    return {
      hasError:
        必須エラー ||
        表紙名エラー ||
        積卸情報エラー ||
        荷主コードエラー ||
        請求内訳エラー ||
        請求区分エラー ||
        稼働手当エラー,
      messages: エラーメッセージList,
    }
  }

  /**
   * グリッド登録
   * @param gridData
   */
  const gridRegister = async () => {
    try {
      const gridItems: T受注配車入力GridItem[] = gridData.data.items
      const putData: TZyutyuHaisyaListGetRes[] = []
      gridItems.forEach((d) => {
        // 品数がnullの場合は1を入れる
        if (!d.品数) {
          d.品数 = 1
        }
        // 複写フラグがある行は選択していなくても登録する
        if (d.複写フラグ) {
          d.受注部所コード = 受注部所コード
          d.受注配車区分コード = 受注配車区分.通常貨物
          d.受領書確認フラグ = d.bl受領書確認フラグ ? 1 : 0

          putData.push(d)
        }
      })
      if (selectedRows) {
        selectedRows.forEach((row) => {
          const dataItem: T受注配車入力GridItem = row?.dataItem
          if (!dataItem?.複写フラグ) {
            const item: TZyutyuHaisyaListGetRes = dataItem
            item.受領書確認フラグ = dataItem.bl受領書確認フラグ ? 1 : 0
            putData.push(item)
          }
        })
      }
      if (putData) {
        putData.forEach((d) => {
          d.受注配車区分コード = 受注配車区分.通常貨物
          // 卸日が入っていない場合自動的に積日に変更
          if (d.荷主請求ID) {
            d.表紙名 = d.荷主請求ID.toString()
          }
          if (d.卸日 == null || d.卸日 === "") {
            d.卸日 = d.積日
          }

          // 傭車の場合は車番が入って入れば配車確定とする
          if (d.支払先ID != null && !wjCore.isNullOrWhiteSpace(d.車番 ?? "")) {
            d.配車状態区分コード = e配車状態区分.配車確定
          } else {
            d.配車状態区分コード = set配車状態区分By車輌ID(d.配車状態区分コード, d.車輌ID)
          }

          // 登録されていない場合、車輌より稼働掛率を登録する
          const target車輌 = 車輌DataList?.find((車輌) => 車輌.車輌ID === d.車輌ID)
          if (target車輌) {
            d.稼働手当車種掛率区分コード = target車輌.稼働手当車種別掛率区分コード
          } else {
            d.稼働手当車種掛率区分コード = ""
          }

          if (d.コース編集 === "" || !d.コース編集) {
            d.コース編集 = createコース編集(d)
          }
          const 請求内訳 = 請求内訳List?.find((i) => i.荷主請求内訳ID === d.荷主請求内訳ID)
          if (請求内訳) {
            // 請求計上日が空白だったら基準日区分に応じた内容を入れる
            if (!d.請求計上日) {
              switch (請求内訳.計上基準日区分名称1) {
                case "積日":
                  d.請求計上日 = d.積日
                  break
                case "卸日":
                  d.請求計上日 = d.卸日
                  break
              }
            }
          }
        })

        const service = new zyutyuHaisyaService()
        let res: TApiResponse<TZyutyuHaisyaListGetRes[]>
        res = await service.putList(putData)
        disPatch(setAlerts(res))
        if (res) {
          isPrompt.current = false
          showInfoToast(`受注配車リストの更新が完了しました`)
          setSelectedRows([])
          search(preSearchCondition)
        }
      } else {
        showInfoToast(`選択されている行がありません。`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * グリッド削除
   * @param gridData
   */
  const gridDelete = async () => {
    try {
      const putData: TZyutyuHaisyaListDeleteReq[] = []
      if (selectedRows) {
        for (let row of selectedRows.filter((row) => {
          const item: T受注配車入力GridItem = row.dataItem
          return item.複写フラグ !== 1
        })) {
          const dataItem: TZyutyuHaisyaListGetRes = row.dataItem
          if (is請求確認済(dataItem)) {
            const messages: string[] = []
            messages.push("請求確認済のデータは削除できません。")
            disPatch(setWarningAlerts(messages))
            return
          } else {
            putData.push({
              受注配車ID: dataItem.受注配車ID,
              更新日時: dataItem.更新日時!,
            })
          }
        }
      }
      if (putData && putData.length > 0) {
        const service = new zyutyuHaisyaService()
        const res = await service.deleteList(putData)
        disPatch(setAlerts(res))
        if (res) {
          isPrompt.current = false
          search()
          showInfoToast(`受注配車リストの削除が完了しました`)
        }
      } else {
        showInfoToast(`選択されている行がありません。`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsDeleteConfirmModalShow(false)
    }
  }

  const checkId = (荷主請求s: T表紙分割[], 請求内訳s: T請求内訳[], flexGrid: wjcGrid.FlexGrid) => {
    if (flexGrid == null) return
    const sourceCollection: T受注配車入力GridItem[] = flexGrid.collectionView.sourceCollection
    sourceCollection.forEach((rowItem) => {
      let isDeleted = false
      if (!荷主請求s.find((n) => n.荷主ID === rowItem.荷主ID && n.荷主請求ID === rowItem.荷主請求ID)) {
        // 荷主請求が存在しなかった場合
        rowItem.荷主請求ID = undefined
        isDeleted = true
      } else if (
        // 請求内訳が存在しなかった場合
        !請求内訳s.find((n) => n.荷主請求ID === rowItem.荷主請求ID && n.荷主請求内訳ID === rowItem.荷主請求内訳ID)
      ) {
        isDeleted = true
      }

      if (isDeleted) {
        rowItem.荷主請求内訳ID = undefined
        rowItem.計上基準日区分ID = undefined
        rowItem.計上基準日区分コード = undefined
        rowItem.計上基準日区分ソート番号 = undefined
        rowItem.計上基準日区分名称1 = undefined
        rowItem.請求計上日 = undefined
        rowItem.請求車輌ID = undefined
        rowItem.請求車輌区分コード = undefined
        rowItem.請求車輌区分ソート番号 = undefined
        rowItem.請求車輌区分名称1 = undefined
        rowItem.請求車番 = undefined
      }
    })
  }

  // パターン検索用
  const getPatternItemsSource = (
    query: string,
    max: number,
    callback: (items: TZyutyuHaisyaPatternListGetRes[]) => void
  ) => {
    if (query == null || wjCore.isNullOrWhiteSpace(query)) {
      callback([])
      return
    } else {
      const service = new ZyutyuHaisyaPatternService()
      return service.getList({ 受注配車パターンコード: query, 受注部所コード }).then((res) => {
        const selectItem = res.data
          ? res.data.map((d) => {
              let displayName = `${d.受注配車パターンコード ?? ""}`
              let detailText = ``
              detailText = commonUtil.addTextWithStartDelimiter(detailText, [
                d.荷主略称1,
                d.積地社名,
                d.卸地社名,
                d.品名,
              ])
              if (detailText !== "") {
                displayName += `: ${detailText}`
              }
              return { ...d, displayName }
            })
          : []

        callback(selectItem)
      })
    }
  }

  const deleteNewRow = () => {
    if (!contextItem && flexGrid?.itemsSource === undefined) {
    } else {
      const newSelectRows: wjcGrid.Row[] = []
      // 選択状態の保持
      const selectedRowIds = flexGrid?.rows
        .filter((r) => r != null && r.dataItem != null && r.dataItem.row_id != null && r.dataItem.isSelected)
        .map((row) => row.dataItem.row_id)
      flexGrid?.itemsSource.remove(contextItem)
      flexGrid?.rows.forEach((row) => {
        if (row.dataItem.row_id == null && contextItem?.row_id === row.dataItem.row_id) return
        if (selectedRowIds?.find((sr) => sr === row.dataItem.row_id)) {
          newSelectRows.push(row)
          row.dataItem.isSelected = true
        }
      })
      setSelectedRows([...newSelectRows])
    }
    setIsDeleteRowConfirmModalShow(false)
  }

  const setPattern = (パターン: TZyutyuHaisyaPatternListGetRes, castedData: TZyutyuHaisyaListGetRes) => {
    setPatternInner(パターン, castedData)
    castedData.受領書有無フラグ = 0
    castedData.受領書確認フラグ = 0
    const target車輌 = 車輌DataList?.find((車輌) => 車輌.車輌ID === castedData.車輌ID)
    if (target車輌) {
      castedData.稼働手当車種掛率区分コード = target車輌.稼働手当車種別掛率区分コード
    } else {
      castedData.稼働手当車種掛率区分コード = ""
    }
  }

  const on編集ボタンClickHandler = (context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => async () => {
    // 分割受注配車の場合、専用の編集画面へ遷移
    let 遷移先URL = 受注配車入力PathList[1].replaceAll(":id", context.item.受注配車ID.toString())
    if (context.item.分割情報) {
      遷移先URL = 分割受注配車入力PathList[1].replaceAll(":id", context.item.分割情報.分割受注配車ID.toString())
    }

    // 画面全体のスクロール位置の保存
    gridPageHelper.savePageConditionData(location.pathname)

    history.push(遷移先URL)
  }

  const 傭車会社検索結果Set = (支払先: 支払先マスタ) => {
    if (選択行 && 選択行.dataItem) {
      const casted: T受注配車入力GridItem = 選択行.dataItem
      casted.支払先ID = 支払先.支払先ID
      casted.支払先コード = 支払先.支払先コード
      casted.傭車会社コード = 支払先.支払先コード
      casted.傭車会社名 = 支払先.支払先名
      if (casted.支払計上日 == null) {
        // 新規に支払計上日を入力する場合は卸日固定
        casted.支払計上日 = casted.卸日
      }
      // 傭車会社選択時に入力されている車輌系の情報をすべて削除する
      clear運行情報At傭車設定時(casted)

      flexGrid?.refresh()
    }
  }

  const 傭車検索結果Set = (傭車: T傭車マスタ) => {
    if (選択行 && 選択行.dataItem) {
      const casted: T受注配車入力GridItem = 選択行.dataItem
      switch (車輌検索用原動機有無フラグ) {
        case 1:
          // 有 車輌
          castヘッド車輌By傭車(casted, 傭車)
          break
        case 0:
          castトレーラ車輌By傭車(casted, 傭車)
          break
        default:
          break
      }
      if (casted.請求車輌区分コード === e請求車輌区分.ヘッド) {
        casted.請求車番 = casted.車番
      }
      if (casted.請求車輌区分コード === e請求車輌区分.トレーラー) {
        casted.請求車番 = casted.トレーラ車番
      }
      flexGrid?.refresh()
    }
  }
  //#endregion

  //#region [baseState]

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //アラート制御
  //   const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [effect]

  //初期表示
  useEffect(() => {
    //区分値の確保
    //TODO: APIより区分の一覧を取得し各dataMapにフィルターしながら設定
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new SiharaisakiService().getList({}),
      new HinmeiService().getList({}),
      new ZyomuinService().getList({
        退職フラグ: 0,
      }),
    ]).then(([部所ListRes, 区分マスタRes, 支払先Res, 品名Res, 乗務員Res]) => {
      set単位区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.マスタ.単位区分),
          "区分コード",
          "名称1"
        )
      )
      set配車状態区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.配車状態区分 && d.区分コード.length < 2 // 受注配車の配車状態区分は1桁
          ),
          "区分コード",
          "名称1"
        )
      )
      set車種区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.車輌.車種区分),
          "区分コード",
          "名称1"
        )
      )
      set支払先DataMap(
        new wjcGrid.DataMap(
          支払先Res.data
            .filter((d) => d.支払先区分コード === e支払先区分.傭車先)
            .map((d) => ({
              ...d,
              displayName: commonUtil.addTextWithStartDelimiter(`${d.支払先コード}:`, [d.支払先略称]),
            })),
          "支払先コード",
          "displayName"
        )
      )

      set請求区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.受注配車_請求支払.請求区分),
          "区分コード",
          "名称1"
        )
      )
      set稼働手当車種掛率区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.受注配車_請求支払.稼働手当車種掛率区分),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分),
          "区分コード",
          "名称1"
        )
      )
      set計上基準日区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.マスタ.計上基準日区分),
          "区分コード",
          "名称1"
        )
      )
      // モーダルに設定するため部所一覧を確保
      set部所List(部所ListRes.data)
      set運行部所DataMap(
        new wjcGrid.DataMap(
          部所ListRes.data.filter((d) => d.運行部所フラグ === 1),
          "部所コード",
          "部所略称"
        )
      )

      set食事手当区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.マスタ.食事手当区分),
          "数値1",
          "数値1"
        )
      )
      setAGC高速料対象荷主コードList(
        区分マスタRes.data
          .filter((d) => d.分類コード === 区分分類コード.受注配車_請求支払.AGC高速料対象荷主コード区分)
          .map((d) => d.名称1)
      )
      set区分ItemSource(区分マスタRes.data)
      set乗務員List(乗務員Res.data)
      setIsListGot(true)
    })
    return () => {
      setFlexGrid(undefined)
    }
  }, [])

  // 初回表紙分割、請求内訳取得用メソッド
  const 荷主請求取得 = async (検索条件: TZyutyuHaisyaListGetRes[]) => {
    const 荷主IdList = _.uniq(検索条件.filter((a) => a.荷主ID != null).map((a) => a.荷主ID as number))

    if (荷主IdList.length <= 0) {
      set表紙分割List([])
      return
    }
    try {
      const res = await new NinusiSeikyuService().getList({
        荷主IdList,
        削除済み包含フラグ: true,
      })

      if (res && res.data && res.data.length > 0) {
        set表紙分割List([..._.orderBy(res.data, (a) => a.表紙分割コード)])
      } else {
        set表紙分割List([])
        return
      }
      const 内訳Res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求IdList: [...res.data.map((d) => d.荷主請求ID)],
      })
      if (内訳Res && 内訳Res.data) {
        set請求内訳List([...内訳Res.data])
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  useEffect(() => {
    if (searchResult == null) return
    // 取得したデータより表紙分割と請求内訳を取得
    荷主請求取得(searchResult)
      .then(async () => {
        const [車輌Res, 傭車Res] = await Promise.all([
          new SyaryoService().getList({
            廃車フラグ: 0,
          }),
          new YosyaService().getList({}),
        ])
        if (車輌Res.data) {
          const dataMap用車輌list = build車輌DataMapList(車輌Res.data)
          set車輌DataList(dataMap用車輌list)
          const new車番DataMap = new wjcGrid.DataMap(dataMap用車輌list, "車番", "displayName")
          new車番DataMap.getDisplayValues = (dataItem: T受注配車入力GridItem) => {
            // 車輌IDで引き当て（別部所の同一車番に対応、KAIROS-1108）
            if (dataItem.車輌ID != null) {
              const byId = dataMap用車輌list.filter((d) => d.車輌ID === dataItem.車輌ID)
              if (byId.length > 0) return byId.map((h) => h.displayName)
            }
            const filteredSource = dataMap用車輌list.filter((d) => d.部所コード === dataItem.運行部所コード)
            return filteredSource.map((h) => h.displayName)
          }
          set車輌DataMap(new車番DataMap)
        }

        if (傭車Res.data) {
          const dataMap用傭車list = 傭車Res.data.map((d) => ({
            ...d,
            displayName: 傭車DisplayNameFunc(d),
          }))
          const new傭車DataMap = new wjcGrid.DataMap(dataMap用傭車list, "車番", "displayName")
          new傭車DataMap.getDisplayValues = (dataItem: T受注配車入力GridItem) => {
            const filteredSource = dataMap用傭車list.filter((d) => d.支払先ID === dataItem.支払先ID)
            return filteredSource.map((h) => h.displayName)
          }
          set傭車DataMap(new傭車DataMap)
        }

        const newGridData: Array<TZyutyuHaisyaListGetRes & T手入力チェック> = [...searchResult]
        // 手入力であるかの確認フラグを追加
        // マスタが取れなかった場合は特に設定しない
        const 積卸先IdList = _.uniq(
          searchResult.flatMap((d) => [d.積地積卸先ID, d.卸地積卸先ID]).filter((d) => d != null)
        ) as number[]
        const 荷主品名IdList = _.uniq(searchResult.flatMap((d) => [d.荷主品名ID]).filter((d) => d != null)) as number[]
        try {
          const 積卸res = await new TumiorosisakiService().getList({
            IdList: 積卸先IdList,
          })
          const 品名res = await new HinmeiService().getList({
            IdList: 荷主品名IdList,
          })
          newGridData.forEach((newD) => {
            if (積卸res && 積卸res.data.length > 0) {
              if (newD.積地積卸先ID != null) {
                const 積情報 = 積卸res.data.find((d) => d.積卸先ID === newD.積地積卸先ID)
                if (積情報) {
                  if (
                    積情報.積卸先略称 !== newD.積地社名 ||
                    積情報.住所１ !== newD.積地都道府県 ||
                    積情報.住所２ !== newD.積地市区町村
                  ) {
                    newD.is積地手編集 = true
                  }
                }
              } else {
                if (
                  wjCore.isNullOrWhiteSpace(newD.積地社名 ?? "") ||
                  wjCore.isNullOrWhiteSpace(newD.積地都道府県 ?? "") ||
                  wjCore.isNullOrWhiteSpace(newD.積地市区町村 ?? "")
                ) {
                  newD.is積地手編集 = true
                }
              }
              if (newD.卸地積卸先ID != null) {
                const 卸情報 = 積卸res.data.find((d) => d.積卸先ID === newD.卸地積卸先ID)
                if (卸情報) {
                  if (
                    卸情報.積卸先略称 !== newD.卸地社名 ||
                    卸情報.住所１ !== newD.卸地都道府県 ||
                    卸情報.住所２ !== newD.卸地市区町村
                  ) {
                    newD.is卸地手編集 = true
                  }
                }
              } else {
                if (
                  wjCore.isNullOrWhiteSpace(newD.卸地社名 ?? "") ||
                  wjCore.isNullOrWhiteSpace(newD.卸地都道府県 ?? "") ||
                  wjCore.isNullOrWhiteSpace(newD.卸地市区町村 ?? "")
                ) {
                  newD.is卸地手編集 = true
                }
              }
            }
            if (品名res && 品名res.data.length > 0) {
              if (newD.荷主品名ID != null) {
                const 品名情報 = 品名res.data.find((d) => d.荷主品名ID === newD.荷主品名ID)
                if (品名情報) {
                  if (品名情報.品名 !== newD.品名 || 品名情報.単位区分コード !== newD.単位区分コード) {
                    newD.is品名手編集 = true
                  }
                }
              } else {
                if (
                  (newD.品名 != null && newD.品名 !== "") ||
                  (newD.単位区分コード != null && newD.単位区分コード !== "")
                ) {
                  newD.is品名手編集 = true
                }
              }
            }
          })
        } catch (error) {
          disPatch(setAlerts(error))
        }

        const GridCollectionView = createCollectionView(newGridData, pageSize)
        setGridData({ data: GridCollectionView })
      })
      .finally(() => {
        // 選択行情報も初期化
        setSelectedRows([])

        flexGrid?.refresh()
        setIsSearching(false)
      })
  }, [searchResult])

  // 荷主コード変更によるdataMap変更用
  useEffect(() => {
    if (flexGrid == null) return
    if (!is荷主コード変更) return
    // 表紙分割Listの更新
    const 表紙分割col = flexGrid.getColumn(nameofT<TZyutyuHaisyaListGetRes>("荷主請求ID"))
    // 外部より取得するためにテーブルの荷主コードをすべて取得する
    const tableData: T受注配車入力GridItem[] = flexGrid.collectionView.sourceCollection
    const 荷主IdList = _.uniq(tableData.map((a) => a.荷主ID as number).filter((a) => a != null))

    if (荷主IdList.length <= 0) {
      if (表紙分割col == null || 表紙分割col.dataMap == null) return
      表紙分割col?.dataMap.collectionView.sourceCollection.splice(
        0,
        表紙分割col?.dataMap.collectionView.sourceCollection.length
      )
      表紙分割col?.dataMap.collectionView.refresh()
      set表紙分割List([])
      setIs荷主コード変更(false)
      return
    }

    new NinusiSeikyuService()
      .getList({
        荷主IdList,
        削除済み包含フラグ: true,
      })
      .then((荷主請求Res) => {
        if (表紙分割col == null || 表紙分割col.dataMap == null) return
        表紙分割col?.dataMap.collectionView.sourceCollection.splice(
          0,
          表紙分割col?.dataMap.collectionView.sourceCollection.length
        )
        表紙分割col?.dataMap.collectionView.sourceCollection.push(...荷主請求Res.data)
        表紙分割col?.dataMap.collectionView.refresh()
        set表紙分割List([...荷主請求Res.data])
        setIs荷主コード変更(false)
      })
      .catch((error) => {
        disPatch(setAlerts(error))
      })
  }, [is荷主コード変更])

  useEffect(() => {
    if (flexGrid == null) return

    util.set表紙分割DataMapFrom荷主コードChanged<TZyutyuHaisyaListGetRes, T表紙分割 & { displayMemberPath: string }>(
      flexGrid,
      表紙分割List.map((d) => ({
        ...d,
        displayMemberPath: `${d.表紙分割コード}: ${d.表紙名} (${d.荷主請求ID})`,
      })),
      "荷主請求ID",
      "荷主請求ID",
      "displayMemberPath",
      set表紙分割DataMap,
      (h) => h.displayMemberPath
    )
    // 請求内訳Listの更新
    const 請求内訳col = flexGrid.getColumn(nameofT<TZyutyuHaisyaListGetRes>("荷主請求内訳ID"))
    const 荷主請求IdList = 表紙分割List.map((a) => a.荷主請求ID)
    if (荷主請求IdList.length <= 0) {
      請求内訳col?.dataMap?.collectionView.sourceCollection.splice(
        0,
        請求内訳col?.dataMap.collectionView.sourceCollection.length
      )
      請求内訳col?.dataMap?.collectionView.refresh()
      set請求内訳List([])
      return
    }
    new NinusiSeikyuService()
      .getListUchiwake({
        荷主請求IdList,
        削除済み包含フラグ: true,
      })
      .then((請求内訳Res) => {
        請求内訳col?.dataMap?.collectionView.sourceCollection.splice(
          0,
          請求内訳col?.dataMap.collectionView.sourceCollection.length
        )
        請求内訳col?.dataMap?.collectionView.sourceCollection.push(...請求内訳Res.data)
        請求内訳col?.dataMap?.collectionView.refresh()
        set請求内訳List([...請求内訳Res.data])
      })
  }, [表紙分割List])

  useEffect(() => {
    if (flexGrid == null) return

    util.setDataMapFrom荷主請求Changed<TZyutyuHaisyaListGetRes, T請求内訳 & { displayMemberPath: string }>(
      flexGrid,
      請求内訳List.map((d) => ({
        ...d,
        displayMemberPath: `${d.請求内訳コード}: ${d.請求内訳名} (${d.荷主請求内訳ID})`,
      })),
      "荷主請求内訳ID",
      "荷主請求内訳ID",
      "displayMemberPath",
      set請求内訳DataMap,
      (h) => h.displayMemberPath
    )
    // 荷主idと荷主請求id、荷主請求内訳idの組み合わせに不備がある場合データを消去
    checkId(表紙分割List, 請求内訳List, flexGrid)
    flexGrid?.refresh()
  }, [請求内訳List])

  useEffect(() => {
    if (isGridRefresh) {
      flexGrid?.refresh()
      setIsGridRefresh(false)
    }
  }, [isGridRefresh])

  useEffect(() => {
    部所List && setSelect受注部所(部所List.find((d) => d.部所コード === 受注部所コード))
  }, [受注部所コード])

  // イベント付替え用のhookに格納する
  const cellEditEndedHandler = useGridEventHandler(flexGrid?.cellEditEnded, cellEditEnded)
  const pastedCellHandler = useGridEventHandler(flexGrid?.pastedCell, pastedCell)

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    if (isListGot) {
      cellEditEndedHandler.refresh()
      pastedCellHandler.refresh()
    }
  }, [表紙分割List, 請求内訳List, 車輌DataList, isListGot, 乗務員List])

  // 休日リストの取得は画面内で一度のみのため
  // 休日リスト取得でエベントを付与し、それ以降動かないようにする
  const [hadGet休日List, setHadGet休日List] = useState(false)
  useEffect(() => {
    if (休日List != null && 休日List.length > 0 && !hadGet休日List) {
      flexGrid?.formatItem.addHandler(formatItem)
      flexGrid?.beginningEdit.addHandler(beginningEdit)
      setHadGet休日List(true)
    }
  }, [休日List])

  // 登録ボタン制御用
  // 登録ボタンが押せるのは選択行が存在するか、新規追加行が存在するときのみ
  useEffect(() => {
    if (flexGrid == null) {
      setIsDisabled登録ボタン(true)
      return
    }
    const gridRow: T受注配車入力GridItem[] = flexGrid.collectionView.sourceCollection
    // 一行も存在しない場合入力不可
    if (gridRow.length <= 0) {
      setIsDisabled登録ボタン(true)
      return
    }
    // 受注部所未選択の場合入力不可
    if (受注部所コード == null || 受注部所コード === "") {
      setIsDisabled登録ボタン(true)
      return
    }
    // 選択行が存在しない場合入力不可
    if (isSearching || selectedRows == null || selectedRows.length <= 0) {
      setIsDisabled登録ボタン(true)
      return
    }
    setIsDisabled登録ボタン(false)
  }, [isSearching.valueOf, selectedRows, 受注部所コード, flexGrid])

  useEffect(() => {
    if (flexGrid == null || searchResult == null) return

    setGridReadOnly(flexGrid)
  }, [flexGrid, selectedRows, searchResult])

  useEffect(() => {
    if (flexGrid == null || gridData == null) return
    setGridReadOnly(flexGrid)
  }, [gridData])

  const setGridReadOnly = (flexGrid: wjcGrid.FlexGrid) => {
    if (selectedRows == null) {
      flexGrid.rows.forEach((r) => (r.isReadOnly = true))
    } else {
      flexGrid.rows.forEach((row: wjcGrid.Row) => {
        const dataItem = row.dataItem as T受注配車入力GridItem

        if (
          selectedRows.find((r) => {
            const selectRowData = r.dataItem as T受注配車入力GridItem
            return selectRowData.row_id === dataItem.row_id
          })
        ) {
          if (
            // 請求支払確認区分が未登録か未確認の時のみisReadOnlyをTrueにする
            dataItem.請求額確認区分コード === e請求支払確認区分.未確認 ||
            dataItem.請求額確認区分コード == null
          ) {
            row.isReadOnly = false
          } else {
            row.isReadOnly = true
          }
        } else {
          row.isReadOnly = true
        }
      })
    }
    if (selectedRows != null && selectedRows.length > 0) {
      flexGrid.isReadOnly = false
    } else {
      flexGrid.isReadOnly = true
    }
    flexGrid.refresh()
  }

  useEffect(() => {
    // 一度でも選択状態の行ができたらtrueにする
    if (!isPrompt.current && selectedRows.length > 0) {
      isPrompt.current = true
      setForceUpdate(!forceUpdate)
    }
  }, [selectedRows])

  //#endregion

  return (
    <>
      <Prompt when={isPrompt.current} message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <input
        type="check"
        style={{ display: "none" }}
        value={forceUpdate ? 0 : 1}
        onChange={(e) => {
          setForceUpdate(e.currentTarget.checked)
        }}></input>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pdfFormatItem={pdfFormat}
        pageNumber={pageNumber}
        searchConditionClear={props.searchConditionClear}
        gridId={props.gridId}
        isRestoreSearching={isRestoreSearching}
        isEnablePageSize={"hidden"}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        gridInitializedHandler={gridInitializedHandler}
        excelFormatItem={excelFormat}
        gridProperties={{
          frozenColumns: 6,
          isReadOnly: true,
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.All,
          keyActionTab: wjcGrid.KeyAction.CycleOut,
        }}
        headerComponent={
          <>
            <Button
              disabled={
                isSearching ||
                selectedRows == null ||
                selectedRows.length <= 0 ||
                selectedRows.filter((row) => {
                  const item: T受注配車入力GridItem = row.dataItem
                  return item.複写フラグ !== 1
                }).length <= 0
              }
              onClick={() => {
                setIs複写Modal(true)
              }}>
              <FontAwesomeIcon icon={faPlusSquare} />
              複写
            </Button>
            <Button
              disabled={isSearching || 受注部所コード == null || 受注部所コード === ""}
              onClick={() => {
                addRow()
              }}>
              <FontAwesomeIcon icon={faPlusSquare} />
              行追加
            </Button>
            <span>
              <Link
                to={`${受注配車入力PathList[0]}`}
                onClick={(e) => {
                  if (isSearching) {
                    e.preventDefault()
                    e.stopPropagation()
                  }
                  gridPageHelper.savePageConditionData(location.pathname)
                }}>
                <Button variant="primary" disabled={isSearching}>
                  <FontAwesomeIcon icon={faPlusSquare} />
                  受注配車入力
                </Button>
              </Link>
            </span>
            <span>
              <Link
                to={`${分割受注配車入力PathList[0]}`}
                onClick={(e) => {
                  if (isSearching) {
                    e.preventDefault()
                    e.stopPropagation()
                  }
                  gridPageHelper.savePageConditionData(location.pathname)
                }}>
                <Button variant="primary" disabled={isSearching}>
                  <FontAwesomeIcon icon={faPlusSquare} />
                  分割受注配車入力
                </Button>
              </Link>
            </span>
            <Button
              className="w-7rem"
              disabled={isDisabled登録ボタン}
              variant="waiting"
              onClick={() => {
                beforeSubmit()
              }}>
              登録
            </Button>
            <Button
              disabled={
                isSearching ||
                selectedRows == null ||
                selectedRows.filter((row) => {
                  const item: T受注配車入力GridItem = row.dataItem
                  return item.複写フラグ !== 1
                }).length !== 1 ||
                受注部所コード == null ||
                受注部所コード === ""
              }
              variant="waiting"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIs受注配車パターン新規登録Modal(true)
              }}>
              パターン登録
            </Button>
            <Button
              disabled={
                isSearching ||
                selectedRows == null ||
                selectedRows.length <= 0 ||
                selectedRows.filter((row) => {
                  const item: T受注配車入力GridItem = row.dataItem
                  return item.複写フラグ !== 1
                }).length <= 0
              }
              style={{ marginLeft: "10rem" }}
              variant="caution"
              onClick={() => {
                if (
                  isSearching ||
                  selectedRows == null ||
                  selectedRows.length <= 0 ||
                  selectedRows.filter((row) => {
                    const item: T受注配車入力GridItem = row.dataItem
                    return item.複写フラグ !== 1
                  }).length <= 0
                ) {
                  showInfoToast(`選択されている行がありません。`)
                } else {
                  setIsDeleteConfirmModalShow(true)
                }
              }}>
              選択行削除
            </Button>
          </>
        }>
        <wjrGrid.FlexGridCellTemplate
          cellType={wjrGrid.CellTemplateType.TopLeft}
          template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
            const grid = context.row.grid
            const checked = grid.rows.length > 0 && selectedRows.length === grid.rows.length
            return (
              <div>
                {context.row.index !== 0 && (
                  <input
                    checked={checked}
                    tabIndex={-1}
                    onChange={(e) => {
                      const rows = grid.rows
                      if (checked) {
                        const newSelectRow: wjcGrid.Row[] = []
                        rows.forEach((r) => {
                          const dataItem: T受注配車入力GridItem = r.dataItem
                          if (dataItem.複写フラグ === 1) {
                            newSelectRow.push(r)
                          } else {
                            r.dataItem.isSelected = false
                            r.cssClass = ""
                          }
                        })
                        setSelectedRows([...newSelectRow])
                      } else {
                        rows.forEach((r) => {
                          r.dataItem.isSelected = true
                          r.cssClass = "edit-row"
                        })
                        setSelectedRows([...rows])
                      }
                    }}
                    type="checkbox"></input>
                )}
              </div>
            )
          }}></wjrGrid.FlexGridCellTemplate>
        <wjrGrid.FlexGridCellTemplate
          cellType={wjrGrid.CellTemplateType.RowHeader}
          template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
            const checked = context.item.isSelected

            // 新規追加行（複写フラグ = 1）の行では常に編集可とするためチェックを出さない
            return context.item.複写フラグ === 1 ? (
              <></>
            ) : (
              <div>
                <input
                  checked={checked}
                  tabIndex={-1}
                  onChange={(e) => {
                    if (checked) {
                      context.row.dataItem.isSelected = false
                      context.row.cssClass = ""
                      setSelectedRows([...selectedRows.filter((row) => row.dataItem.row_id !== context.item.row_id)])
                    } else {
                      context.row.dataItem.isSelected = true
                      context.row.cssClass = "edit-row"
                      setSelectedRows([...selectedRows, context.row])
                      flexGrid?.select(new wjcGrid.CellRange(context.row.index, 1), true)
                      flexGrid?.focus(true)
                    }
                  }}
                  type="checkbox"></input>
              </div>
            )
          }}></wjrGrid.FlexGridCellTemplate>
        <wjrGrid.FlexGridColumn
          variant="waiting"
          header="編集"
          cssClassAll={"read-only-cell"}
          allowDragging={false}
          hasFilter={false}
          allowSorting={false}
          binding="受注配車id"
          allowMerging={true}
          selectable={false}
          align="center"
          width={60}
          isReadOnly>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              if (context.item.複写フラグ) {
                return (
                  <Button
                    type="button"
                    variant="caution"
                    tabIndex={-1}
                    className="btn btn-small btn-primary move-edit-page"
                    onClick={(e) => {
                      e.preventDefault()
                      setContextItem(context.item)
                      setIsDeleteRowConfirmModalShow(true)
                    }}>
                    削除
                  </Button>
                )
              } else {
                return (
                  <Button
                    type="button"
                    tabIndex={-1}
                    className="btn btn-small btn-primary move-edit-page"
                    onClick={on編集ボタンClickHandler(context)}>
                    編集
                  </Button>
                )
              }
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注No"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={110}
          header="受注No">
          <wjrGrid.FlexGridCellTemplate
            cellType={wjrGrid.CellTemplateType.ColumnHeader}
            template={() => <div style={{ height: "100%" }}>受注No</div>}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        {/* パターン検索 */}
        <wjrGrid.FlexGridColumn
          binding="受注配車パターンコード"
          width={110}
          header="パターンCD"
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              delay: 300,
              itemsSourceFunction: getPatternItemsSource,
              displayMemberPath: "displayName",
              selectedValuePath: "受注配車パターンコード",
            })
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.受注配車パターンコード}</div>
                  {!flexGrid?.isReadOnly &&
                    !context.row.isReadOnly &&
                    (context.item.受注配車ID == null || context.item.受注配車ID === 0) && (
                      <div className="text-end">
                        <a
                          href="*"
                          onClick={(e) => {
                            e.preventDefault()
                            setモーダル検索用荷主コード(context.item.荷主コード)
                            setモーダル検索用荷主名(context.item.荷主名)
                            set選択行(context.row)
                            setIs受注配車パターン検索Modal(true)
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                        </a>
                      </div>
                    )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        {/* 荷主 */}
        <wjrGrid.FlexGridColumn
          binding="荷主コード"
          width={90}
          isRequired={false}
          header="荷主CD"
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              minLength: 2,
              isEditable: true,
              delay: 300,
              itemsSourceFunction: (query: string, max: number, callback: wjcInput.IGetItemsCallback) => {
                return get荷主ItemsSourceByApi(query, max, callback)
              },
              displayMemberPath: "displayName",
              selectedValuePath: "荷主コード",
            })
          }>
          <RequiredHeader></RequiredHeader>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.荷主コード}</div>
                  {cellReadOnlyFlag(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          setIs荷主検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主名"
          width={200}
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          header="荷主名"></wjrGrid.FlexGridColumn>
        {/* <wjrGrid.FlexGridColumn
          binding="荷主請求ID"
          width={128}
          isRequired={false}
          header="荷主請求ID">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>
            ) => {
              return <>{context.item.荷主請求ID}</>
            }}
          />
        </wjrGrid.FlexGridColumn> */}
        <wjrGrid.FlexGridColumn
          binding="荷主請求ID"
          width={128}
          isRequired={false}
          dataMap={表紙分割DataMap}
          header="表紙名">
          <RequiredHeader></RequiredHeader>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主依頼番号"
          width={128}
          isRequired={false}
          header="荷主依頼No"></wjrGrid.FlexGridColumn>
        {/* 積卸日 */}
        <wjrGrid.FlexGridColumn
          binding="積日"
          width={96}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              gotFocus: (control: wjcInput.InputDate) => {
                control.isDroppedDown = true
              },
              format: "MMdd",
            })
          }
          format={"d"}
          header="積日">
          <RequiredHeader></RequiredHeader>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>) => {
              let dt = ""
              if (context.item.積日) dt = dayjs(context.item.積日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        {/* 積卸時間 */}
        <wjrGrid.FlexGridColumn binding="積時間" width={80} isRequired={false} header="積時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸日"
          width={96}
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              gotFocus: (control: wjcInput.InputDate) => {
                control.isDroppedDown = true
              },
              format: "MMdd",
            })
          }
          format={"d"}
          header="卸日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>) => {
              let dt = ""
              if (context.item.卸日) dt = dayjs(context.item.卸日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="卸時間" width={80} isRequired={false} header="卸時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地数"
          width={32}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          wordWrap={true}
          align="right"
          format="n0"
          header="積地数"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地数"
          width={32}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          wordWrap={true}
          align="right"
          format="n0"
          header="卸地数"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="品数"
          width={32}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          wordWrap={true}
          dataType={2}
          format="n0"
          header="品数"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="繰返運行数"
          width={32}
          wordWrap={true}
          isRequired={false}
          align="right"
          format="n0"
          header="繰返数"></wjrGrid.FlexGridColumn>
        {/* 積卸地 */}
        <wjrGrid.FlexGridColumn
          width={80}
          binding="積地積卸先コード"
          header="積地CD"
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              minLength: 1,
              isEditable: true,
              delay: 300,
              itemsSourceFunction: (query: string, max: number, callback: wjcInput.IGetItemsCallback) => {
                const 荷主コード = editedRowData.current?.荷主コード
                if (荷主コード == null || 荷主コード === "") {
                  callback([])
                  return
                }
                return get積卸ItemsSourceByApi(query, max, callback, 荷主コード)
              },
              displayMemberPath: "displayName",
              selectedValuePath: "積卸先コード",
            })
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.積地積卸先コード}</div>
                  {cellReadOnlyFlag(context) && (context.item.積地数 == null || !(context.item.積地数 > 1)) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          setモーダル検索用荷主コード(context.item.荷主コード)
                          setモーダル検索用荷主名(context.item.荷主名)
                          set選択行(context.row)
                          set積卸先検索対象("積")
                          setIs積卸先検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地社名"
          width={150}
          isRequired={false}
          header="積地社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地都道府県"
          width={100}
          isRequired={false}
          header="都道府県"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地市区町村"
          width={100}
          isRequired={false}
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          width={80}
          binding="卸地積卸先コード"
          header="卸地CD"
          isRequired={false}
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              minLength: 1,
              isEditable: true,
              delay: 300,
              itemsSourceFunction: (query: string, max: number, callback: wjcInput.IGetItemsCallback) => {
                const 荷主コード = editedRowData.current?.荷主コード
                if (荷主コード == null || 荷主コード === "") {
                  callback([])
                  return
                }
                return get積卸ItemsSourceByApi(query, max, callback, 荷主コード)
              },
              displayMemberPath: "displayName",
              selectedValuePath: "積卸先コード",
            })
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.卸地積卸先コード}</div>
                  {cellReadOnlyFlag(context) && (context.item.卸地数 == null || !(context.item.卸地数 > 1)) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          setモーダル検索用荷主コード(context.item.荷主コード)
                          setモーダル検索用荷主名(context.item.荷主名)
                          set選択行(context.row)
                          set積卸先検索対象("卸")
                          setIs積卸先検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地社名"
          width={150}
          isRequired={false}
          header="卸地社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地都道府県"
          width={100}
          isRequired={false}
          header="都道府県"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地市区町村"
          width={100}
          isRequired={false}
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="輸送備考"
          width={150}
          isRequired={false}
          header="輸送備考"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="配車状態区分コード"
          dataMap={配車状態区分DataMap}
          isRequired={false}
          header="配車状態"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注部所コード"
          dataMap={運行部所DataMap}
          width={100}
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          header="受注部所"></wjrGrid.FlexGridColumn>
        {/* 車輌 */}
        <wjrGrid.FlexGridColumn
          binding="運行部所コード"
          dataMap={運行部所DataMap}
          isRequired={false}
          header="運行部所"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払先コード"
          width={100}
          dataMap={支払先DataMap}
          isRequired={false}
          header="傭車先CD"
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              itemsSource: 支払先DataMap?.collectionView,
              headerPath: "支払先コード",
              minLength: 1,
              delay: 300,
              itemsSourceFunction: (query: string, max: number, callback: wjcInput.IGetItemsCallback) =>
                itemsSourceFunctionSearchOuterDataMap(query, max, callback, 支払先DataMap, "支払先コード", true),
              displayMemberPath: "displayName",
              selectedValuePath: "支払先コード",
            })
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.支払先コード}</div>
                  <div className="text-end">
                    {!flexGrid?.isReadOnly && !context.row.isReadOnly && (
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          setIs傭車先検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    )}
                  </div>
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="傭車会社名"
          width={150}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="傭車会社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車番"
          sortMemberPath={"padding車番"}
          header="ヘッド車番"
          isRequired={false}
          width={100}
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              minLength: 1,
              delay: 10,
              isEditable: false,
              headerPath: "車番",
              showDropDownButton: false,
              gotFocus: (control: wjcInput.AutoComplete) => {
                const rowData = editedRowData.current
                control.isEditable = rowData?.支払先ID != null
                if (rowData?.支払先ID != null) {
                  control.itemsSourceFunction = get傭車itemsSourceFunctionByDataMap(傭車DataMap, 1, rowData.支払先ID)
                } else {
                  control.itemsSourceFunction = (q, m, c) =>
                    get車輌itemsSourceFunctionByDataMap(q, m, c, 1, 車輌DataMap, editedRowData)
                }
              },
              displayMemberPath: "displayName",
              selectedValuePath: "車番",
            })
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item?.車番}</div>
                  {!flexGrid?.isReadOnly && !context.row.isReadOnly && (
                    <div className="text-end">
                      <a href="*" onClick={ヘッド車輛検索ButtonOnCLickHandler(context)}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        {/* <wjrGrid.FlexGridColumn
          binding="車輌ID"
          width={60}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="ヘッド車輌ID"></wjrGrid.FlexGridColumn> */}
        <wjrGrid.FlexGridColumn
          binding="車種区分名称1"
          width={130}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          dataMap={車種区分DataMap}
          header="ヘッド車種"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラ車番"
          sortMemberPath={"paddingトレーラ車番"}
          isRequired={false}
          header="トレ車番"
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              itemsSource: 車輌DataMap?.collectionView,
              minLength: 1,
              delay: 10,
              isEditable: false,
              showDropDownButton: false,
              headerPath: "車番",
              gotFocus: (control: wjcInput.AutoComplete) => {
                const rowData = editedRowData.current
                control.isEditable = rowData?.支払先ID != null
                if (rowData?.支払先ID != null) {
                  control.itemsSourceFunction = get傭車itemsSourceFunctionByDataMap(傭車DataMap, 0, rowData.支払先ID)
                } else {
                  control.itemsSourceFunction = (q, m, c) =>
                    get車輌itemsSourceFunctionByDataMap(q, m, c, 0, 車輌DataMap, editedRowData)
                }
              },
              displayMemberPath: "displayName",
              selectedValuePath: "車番",
            })
          }>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item?.トレーラ車番}</div>
                  {!flexGrid?.isReadOnly && !context.row.isReadOnly && (
                    <div className="text-end">
                      <a href="*" onClick={トレーラ車輛検索ButtonOnCLickHandler(context)}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラ車種区分名称1"
          width={130}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="トレーラ車種"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車輌最大積載量"
          width={100}
          cssClass="number-col"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          dataType={wjCore.DataType.Number}
          header="最大積載量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員名"
          header="運転者"
          isRequired={false}
          editor={new wjcInput.AutoComplete(document.createElement("div"), 乗務員AutoCompleteProperties)}>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.乗務員名}</div>
                  {!flexGrid?.isReadOnly && !context.row.isReadOnly && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set乗務員検索対象("乗務員")
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="同乗者名"
          header="同乗者"
          isRequired={false}
          editor={new wjcInput.AutoComplete(document.createElement("div"), 同乗者AutoCompleteProperties)}>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>) => {
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.同乗者名}</div>
                  {!flexGrid?.isReadOnly && !context.row.isReadOnly && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          set選択行(context.row)
                          set乗務員検索対象("同乗者")
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        {/* 品名 */}
        <wjrGrid.FlexGridColumn
          width={80}
          binding="品コード"
          header="品CD"
          editor={
            new wjcInput.AutoComplete(document.createElement("div"), {
              minLength: 1,
              isEditable: true,
              delay: 300,
              itemsSourceFunction: (query: string, max: number, callback: wjcInput.IGetItemsCallback) => {
                const 荷主コード = editedRowData.current?.荷主コード
                if (荷主コード == null || 荷主コード === "") {
                  callback([])
                  return
                }
                return get品名ItemsSourceByApi(query, max, callback, 荷主コード)
              },
              displayMemberPath: "displayName",
              selectedValuePath: "荷主コード",
            })
          }
          isRequired={false}>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              const is複数品数 = context.item.品数 != null && context.item.品数 > 1
              return (
                <div className="d-flex justify-content-between">
                  <div className="text-start">{context.item.品コード}</div>
                  {!is複数品数 && cellReadOnlyFlag(context) && (
                    <div className="text-end">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          setモーダル検索用荷主コード(context.item.荷主コード)
                          setモーダル検索用荷主名(context.item.荷主名)
                          set選択行(context.row)
                          setIs品名検索Modal(true)
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="品名" width={150} isRequired={false} header="品名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積載品数量"
          width={100}
          isRequired={false}
          dataType={wjCore.DataType.Number}
          format={"N3"}
          editor={
            new wjcInput.InputNumber(document.createElement("div"), {
              format: "N3",
              isRequired: false,
            })
          }
          header="数量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="単位区分コード"
          width={64}
          isRequired={false}
          header="単位"
          dataMap={単位区分DataMap}></wjrGrid.FlexGridColumn>
        {/* 請求 */}
        {/* <wjrGrid.FlexGridColumn
          binding="荷主請求内訳ID"
          width={128}
          isRequired={false}
          header="荷主請求内訳ID">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>
            ) => {
              return <>{context.item.荷主請求内訳ID}</>
            }}
          />
        </wjrGrid.FlexGridColumn> */}
        <wjrGrid.FlexGridColumn
          binding="荷主請求内訳ID"
          width={150}
          isRequired={false}
          dataMap={請求内訳DataMap}
          header="請求内訳">
          <RequiredHeader></RequiredHeader>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="請求区分コード" isRequired={false} dataMap={請求区分DataMap} header="請求区分">
          <RequiredHeader></RequiredHeader>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="単価"
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="数量単価"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求車番"
          header="請求車番"
          sortMemberPath={"padding請求車番"}
          cssClassAll={"read-only-cell"}
          maxLength={4}
          isReadOnly={true}
          isRequired={false}
          width={100}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn isReadOnly={true} binding="履歴検索" width={70} header="履歴">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>) => {
              return (
                <a
                  href="*"
                  onClick={(e) => {
                    e.preventDefault()
                    // setSelectRow(context.row)
                    // setIsModalShow(true)
                  }}>
                  {/* 実装したらcolor={"gray"}を消す */}
                  <FontAwesomeIcon icon={faSearch} color={"gray"} />
                </a>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn binding="タリフ検索" width={80} header="タリフ">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>) => {
              return (
                <a
                  href="*"
                  onClick={(e) => {
                    e.preventDefault()
                    // setSelectRow(context.row)
                    // setIsModalShow(true)
                  }}>
                  {/* 実装したらcolor={"gray"}を消す */}
                  <FontAwesomeIcon icon={faSearch} color={"gray"} />
                </a>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求運送料課税区分コード"
          width={84}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求運送料"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求付帯料課税区分コード"
          width={84}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求付帯料"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求高速料税込区分名称1"
          width={70}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="込/抜"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求高速料"
          width={120}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="高速料(税込)">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<T受注配車入力GridItem>) => {
              return (
                <div className="d-flex justify-content-end">
                  <div className="text-end">{context.item?.請求高速料?.toLocaleString()}</div>
                  {!flexGrid?.isReadOnly && !context.row.isReadOnly && (
                    <div className="text-end" style={{ marginLeft: "0.5rem" }}>
                      <a
                        href="*"
                        onClick={(e) => {
                          set選択行(context.row)
                          if (AGC高速料対象荷主コードList.includes(context.item.荷主コード)) {
                            e.preventDefault()
                            setIsAGC高速料検索Modal(true)
                          } else {
                            e.preventDefault()
                            setモーダル検索用荷主名(context.item.荷主名)
                            setモーダル検索用車番(context.item.車番)
                            setモーダル検索用乗務員名(context.item.乗務員名)
                            setモーダル検索用積日(context.item.積日)
                            setモーダル検索用卸日(context.item.卸日)
                            setモーダル検索用積地(context.item.積地市区町村)
                            setモーダル検索用卸地(context.item.卸地市区町村)
                            setモーダル検索用受注配車ID(context.item.受注配車ID)
                            setモーダル検索用高速料IDList(context.item.高速料IDList)
                            setIs高速料検索Modal(true)
                          }
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                      </a>
                    </div>
                  )}
                </div>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求合計"
          width={100}
          cssClass="number-col"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="請求合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="計上基準日区分コード"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          isRequired={false}
          dataMap={計上基準日区分DataMap}
          header="請求基準日"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求計上日"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          isRequired={false}
          format={"d"}
          header="請求計上日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>) => {
              let dt = ""
              if (context.item.請求計上日) dt = dayjs(context.item.請求計上日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求備考"
          width={150}
          isRequired={false}
          header="請求備考"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求額確認区分名称1"
          width={100}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          isRequired={false}
          header="請求額確認"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="高速料記号"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          isRequired={false}
          header="高速料記号"></wjrGrid.FlexGridColumn>
        {/* 運転手売上 */}
        <wjrGrid.FlexGridColumn
          binding="食事手当"
          width={100}
          isRequired={false}
          dataMap={食事手当区分DataMap}
          header="食事手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員売上額"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="乗務員売上"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員付帯料"
          width={120}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="乗務員付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="付帯高速料"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="付帯高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="is乗務員売上手編集"
          width={100}
          dataType={wjCore.DataType.Boolean}
          header="手入力"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="特別手当"
          width={100}
          cssClass="number-col"
          cssClassAll={"read-only-cell"}
          isRequired={false}
          isReadOnly={true}
          dataType={wjCore.DataType.Number}
          header="特別手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="稼働手当車種掛率区分コード"
          width={100}
          isRequired={false}
          cssClassAll={"read-only-cell"}
          dataMap={稼働手当車種掛率区分DataMap}
          isReadOnly={true}
          header="稼働掛率"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="同乗者売上額"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="同乗者売上"></wjrGrid.FlexGridColumn>
        {/* 支払 */}
        <wjrGrid.FlexGridColumn
          binding="支払運送料"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="支払運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払付帯料"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="支払付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払高速料"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="支払高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払合計"
          width={100}
          cssClass="number-col"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="支払合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="支払計上日"
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "yyyyMMdd",
              placeholder: "yyyymmdd",
            })
          }
          format={"d"}
          header="支払計上日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>) => {
              let dt = ""
              if (context.item.支払計上日) dt = dayjs(context.item.支払計上日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払備考"
          isRequired={false}
          width={150}
          header="支払備考"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受領書有無フラグ"
          dataMap={受領書DataMap}
          width={80}
          header="有無"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="bl受領書確認フラグ"
          dataType={wjCore.DataType.Boolean}
          width={80}
          header="確認"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
      {/* モーダル */}
      {/* 複写 */}
      <ModalOuter
        size="lg"
        setIsShow={setIs複写Modal}
        isShow={is複写Modal}
        title="複写"
        footer={
          <>
            <Button
              onClick={(e) => {
                複写(e, "枝番")
                setIs複写Modal(false)
              }}>
              枝番として複写する
            </Button>
            <Button
              onClick={(e) => {
                複写(e, "別受注")
                setIs複写Modal(false)
              }}>
              別受注で複写する
            </Button>
          </>
        }>
        <div>以下の受注Noを複写します</div>
        <ul>
          {selectedRows
            ?.filter((row) => {
              const item: T受注配車入力GridItem = row.dataItem
              return item.複写フラグ !== 1
            })
            .map((row: wjcGrid.Row) => {
              const item: T受注配車入力GridItem = row.dataItem
              return <li key={item.受注伝票番号}>{item.受注伝票番号}</li>
            })}
        </ul>
      </ModalOuter>
      {/* 受注配車パターン新規登録 */}
      <ZyutyuHaisyaPatternRegisterModal
        isShow={is受注配車パターン新規登録Modal}
        setIsShow={setIs受注配車パターン新規登録Modal}
        data={
          selectedRows != null && selectedRows.length > 0 ? selectedRows[0].dataItem : undefined
        }></ZyutyuHaisyaPatternRegisterModal>
      {/* 荷主検索 */}
      <NinusiSeikyuSearchModal
        isShow={is荷主検索Modal}
        setIsShow={setIs荷主検索Modal}
        setNinusi={(荷主請求) => {
          if (選択行 == null || 選択行.dataItem == null) return
          const casted: TZyutyuHaisyaListGetRes = 選択行.dataItem
          casted.荷主ID = 荷主請求.荷主ID
          casted.荷主コード = 荷主請求.荷主コード
          casted.荷主名 = 荷主請求.荷主略称1
          casted.表紙分割コード = 荷主請求.表紙分割コード
          casted.荷主請求ID = 荷主請求.荷主請求ID
          casted.表紙名 = 荷主請求.表紙名
          if (!casted.荷主依頼番号) {
            casted.荷主依頼番号 = 荷主請求.荷主依頼番号接頭辞
          }
          casted.請求高速料税込区分コード = 荷主請求.高速料税込区分コード
          casted.請求高速料税込区分名称1 = 荷主請求.高速料税込区分名称1
          casted.支払高速料税込区分コード = 荷主請求.高速料税込区分コード
          casted.品代端数計算区分コード = 荷主請求.品代端数計算区分コード
          casted.品代端数計算区分ソート番号 = 荷主請求.品代端数計算区分ソート番号
          casted.品代端数計算区分名称1 = 荷主請求.品代端数計算区分名称1
          setIs荷主コード変更(true)
          flexGrid?.refresh()
        }}></NinusiSeikyuSearchModal>
      {/* 受注配車パターン検索 */}
      <ZyutyuHaisyaPatternModal
        isShow={is受注配車パターン検索Modal}
        setIsShow={setIs受注配車パターン検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        zyutyubusyo={select受注部所}
        setPattern={(受注配車パターン) => {
          if (選択行 == null || 選択行.dataItem == null) return
          const casted: T受注配車入力GridItem = 選択行.dataItem
          setPattern(受注配車パターン, casted)

          setIs荷主コード変更(true)
          flexGrid?.refresh()
        }}></ZyutyuHaisyaPatternModal>
      {/* 積卸先検索 */}
      <TumiOrosiSakiSearchModal
        size="lg"
        setIsShow={setIs積卸先検索Modal}
        isShow={is積卸先検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        setTumiOrosiSaki={(積卸先) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T受注配車入力GridItem = 選択行.dataItem
            cast積卸先(casted, 積卸先, 積卸先検索対象)
            flexGrid?.refresh()
          }
        }}></TumiOrosiSakiSearchModal>
      {/* 品名検索 */}
      <HinmeiSearchModal
        size="lg"
        setIsShow={setIs品名検索Modal}
        isShow={is品名検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        setHinmei={(品名) => {
          if (選択行 && 選択行.dataItem) {
            cast品名(選択行.dataItem, 品名)
            flexGrid?.refresh()
          }
        }}></HinmeiSearchModal>
      {/* 車輌検索 */}
      <SyaryoSearchModal
        setIsShow={(v) => {
          setIs車輌検索Modal(v)
        }}
        isShow={is車輌検索Modal}
        busyoCode={全部所車番検索Enabled ? undefined : 車輌検索用部所コード}
        原動機有無フラグ={車輌検索用原動機有無フラグ}
        setSyaryo={(車輌) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T受注配車入力GridItem = 選択行.dataItem
            switch (車輌検索用原動機有無フラグ) {
              case 1:
                // 有 車輌
                castヘッド車輌(casted, 車輌)
                break
              case 0:
                castトレーラ車輌(casted, 車輌)
                break
              default:
                break
            }
            if (casted.請求車輌区分コード === e請求車輌区分.ヘッド) {
              casted.請求車番 = casted.車番
            }
            if (casted.請求車輌区分コード === e請求車輌区分.トレーラー) {
              casted.請求車番 = casted.トレーラ車番
            }
            flexGrid?.refresh()
          }
        }}></SyaryoSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T受注配車入力GridItem = 選択行.dataItem
            cast乗務員(casted, 乗務員, 乗務員検索対象)
            // 同乗者の場合はそのまま乗務員売上から同乗者売上も設定
            if (乗務員検索対象 === "同乗者") {
              casted.同乗者売上額 = 同乗者売上計算(casted.乗務員売上額)
            }
            flexGrid?.refresh()
          }
        }}></ZyomuinSearchModal>
      {/* 傭車先検索 */}
      <SiharaisakiSearchModal
        siharaisakiKubun={"傭車先"}
        isShow={is傭車先検索Modal}
        setIsShow={setIs傭車先検索Modal}
        setSiharaisaki={傭車会社検索結果Set}></SiharaisakiSearchModal>
      {/* 傭車検索 */}
      <YosyaSearchModal
        setIsShow={setIs傭車検索Modal}
        isShow={is傭車検索Modal}
        isReadOnly={true}
        yosyaSakiCode={車輌検索用傭車会社コード}
        setYosya={傭車検索結果Set}></YosyaSearchModal>
      {/* 受注請求履歴検索 */}
      {/* 運賃タリフ検索 */}
      {/* 運賃タリフ検索　AGCロジ高速料 */}
      {/* ETC高速料 */}
      <KosokuryoSearchModal
        syaban={モーダル検索用車番}
        ninusi={モーダル検索用荷主名}
        zyomuin={モーダル検索用乗務員名}
        tumiDay={モーダル検索用積日}
        orosiDay={モーダル検索用卸日}
        tumiName={モーダル検索用積地}
        oroshiName={モーダル検索用卸地}
        isShow={is高速料検索Modal}
        idlist={モーダル検索用高速料IDList}
        zyutyuhaisyaID={モーダル検索用受注配車ID}
        setIsShow={setIs高速料検索Modal}
        setKosokuryo={(高速料) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T受注配車入力GridItem = 選択行.dataItem
            casted.請求高速料 = 高速料.reduce((result, data) => {
              return result + (data.金額 ?? 0)
            }, 0)
            casted.付帯高速料 = casted.請求高速料
            casted.高速料IDList = 高速料.map((d) => d.高速料ID)
            flexGrid?.refresh()
          }
        }}></KosokuryoSearchModal>
      <AGCKosokuryoSearchModal
        isShow={isAGC高速料検索Modal}
        setIsShow={setIsAGC高速料検索Modal}
        setAGCKosokuryo={(AGC高速料) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T受注配車入力GridItem = 選択行.dataItem
            casted.AGC高速料マスタID = AGC高速料.AGC高速料マスタID
            casted.高速料記号 = AGC高速料.高速料記号
            // 請求高速料に入れるのは常に税込金額
            casted.請求高速料 = AGC高速料.高速料税込
            // 付帯高速料更新
            if (!casted.is乗務員売上手編集) {
              casted.付帯高速料 = AGC高速料.高速料税込
            }
            flexGrid?.refresh()
          }
        }}></AGCKosokuryoSearchModal>
      <ConfirmModal isShow={isConfirmModalShow} hideHandler={setIsConfirmModalShow} submitHandler={gridRegister}>
        入力された内容で更新しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDeleteConfirmModalShow}
        hideHandler={setIsDeleteConfirmModalShow}
        submitHandler={gridDelete}>
        選択行を削除しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDeleteRowConfirmModalShow}
        hideHandler={setIsDeleteRowConfirmModalShow}
        submitHandler={deleteNewRow}>
        追加した行を削除しますか？
      </ConfirmModal>
    </>
  )
}
export default ZyutyuHaisyaListGrid
